export const staticOptions = [
  {
    label: <i>None</i>,
    value: null,
  },
  {
    label: " Cryogenic operation engineers",
    value: " Cryogenic operation engineers",
  },
  {
    label: " LHC Effective Field Theory WG",
    value: " LHC Effective Field Theory WG",
  },
  {
    label: "13kA EE systems",
    value: "13kA EE systems",
  },
  {
    label: "157-users",
    value: "157-users",
  },
  {
    label: "186-R-206 (DSF clean room) access list",
    value: "186-R-206 (DSF clean room) access list",
  },
  {
    label: "20-11-2027",
    value: "20-11-2027",
  },
  {
    label: "26-R-012001 IT Users",
    value: "26-R-012001 IT Users",
  },
  {
    label: "28-12-2026",
    value: "28-12-2026",
  },
  {
    label: "3DET collaboration",
    value: "3DET collaboration",
  },
  {
    label: "3T mailing list",
    value: "3T mailing list",
  },
  {
    label: "A New QCD facility at SPS M2 beam line",
    value: "A New QCD facility at SPS M2 beam line",
  },
  {
    label: "A.P.E.G.",
    value: "A.P.E.G.",
  },
  {
    label: "Aadministrators of CERN IR Bulletin Service",
    value: "Aadministrators of CERN IR Bulletin Service",
  },
  {
    label: "AAS SVN E-group",
    value: "AAS SVN E-group",
  },
  {
    label: "ABT system automation",
    value: "ABT system automation",
  },
  {
    label: "ACAT",
    value: "ACAT",
  },
  {
    label: "ACAT conference series",
    value: "ACAT conference series",
  },
  {
    label: "Accelerator and experiments beam instrumentation",
    value: "Accelerator and experiments beam instrumentation",
  },
  {
    label: "Accelerator Beam Feedback Systems",
    value: "Accelerator Beam Feedback Systems",
  },
  {
    label: "Accelerator Beam instrumentation",
    value: "Accelerator Beam instrumentation",
  },
  {
    label: "Accelerator Beam Transfer Support",
    value: "Accelerator Beam Transfer Support",
  },
  {
    label: "Accelerator consolidation",
    value: "Accelerator consolidation",
  },
  {
    label: "Accelerator Controls",
    value: "Accelerator Controls",
  },
  {
    label: "Accelerator Controls Hardware Infrastructure",
    value: "Accelerator Controls Hardware Infrastructure",
  },
  {
    label: "Accelerator operation",
    value: "Accelerator operation",
  },
  {
    label: "Accelerator Operators",
    value: "Accelerator Operators",
  },
  {
    label: "Accelerator Physics",
    value: "Accelerator Physics",
  },
  {
    label: "Accelerators Controls Configuration",
    value: "Accelerators Controls Configuration",
  },
  {
    label: "Accelerators Radio Frequency Linacs",
    value: "Accelerators Radio Frequency Linacs",
  },
  {
    label: "Accelerators Scheduling",
    value: "Accelerators Scheduling",
  },
  {
    label: "access",
    value: "access",
  },
  {
    label: "ACCESS CONTROL",
    value: "ACCESS CONTROL",
  },
  {
    label: "Access in DSS in CMS",
    value: "Access in DSS in CMS",
  },
  {
    label: "Accounts Payable",
    value: "Accounts Payable",
  },
  {
    label: "Accs Control Oracle databases",
    value: "Accs Control Oracle databases",
  },
  {
    label: "ACRON",
    value: "ACRON",
  },
  {
    label: "ACTAR data",
    value: "ACTAR data",
  },
  {
    label: "Active Directory",
    value: "Active Directory",
  },
  {
    label: "AD  ELENA Beam Request Server",
    value: "AD  ELENA Beam Request Server",
  },
  {
    label: "AD-ECooler",
    value: "AD-ECooler",
  },
  {
    label: "AD-exp",
    value: "AD-exp",
  },
  {
    label: "AD-TARG",
    value: "AD-TARG",
  },
  {
    label: "ADAM  - LIGHT",
    value: "ADAM  - LIGHT",
  },
  {
    label: "admin",
    value: "admin",
  },
  {
    label: "Admin e-group for Hard Probes 2024 LOC",
    value: "Admin e-group for Hard Probes 2024 LOC",
  },
  {
    label: "Admin for ALICE-IT-monthly",
    value: "Admin for ALICE-IT-monthly",
  },
  {
    label: "Admin of UCSD-DuarteLab egroup",
    value: "Admin of UCSD-DuarteLab egroup",
  },
  {
    label: "Administration of Caltech CMS email list",
    value: "Administration of Caltech CMS email list",
  },
  {
    label: "Administrative list for event QCDchallengesPPtoAA-PD2023",
    value: "Administrative list for event QCDchallengesPPtoAA-PD2023",
  },
  {
    label: "Administrative Sector Reporting",
    value: "Administrative Sector Reporting",
  },
  {
    label: "Administrators for FoCal Groups",
    value: "Administrators for FoCal Groups",
  },
  {
    label: "Administrators of the SimP1 LanDB set",
    value: "Administrators of the SimP1 LanDB set",
  },
  {
    label: "Admins for PUMA",
    value: "Admins for PUMA",
  },
  {
    label: "admins of alice-pag-hf-hfcj-Dh",
    value: "admins of alice-pag-hf-hfcj-Dh",
  },
  {
    label: "admins of big egroups with loose posting restrictions ",
    value: "admins of big egroups with loose posting restrictions ",
  },
  {
    label: "Admins of CS-CCR machines in BE BI",
    value: "Admins of CS-CCR machines in BE BI",
  },
  {
    label: "Admins of LHC feedback machines",
    value: "Admins of LHC feedback machines",
  },
  {
    label: "Admins of the ermis-lbaas management service",
    value: "Admins of the ermis-lbaas management service",
  },
  {
    label: "Admins of the Git repository of the CMS ExoDiBosonResonances",
    value: "Admins of the Git repository of the CMS ExoDiBosonResonances",
  },
  {
    label: "AEgIS Data Analysis",
    value: "AEgIS Data Analysis",
  },
  {
    label: "AEgIS DFS group",
    value: "AEgIS DFS group",
  },
  {
    label: "AEgIS Experiment Collaboration",
    value: "AEgIS Experiment Collaboration",
  },
  {
    label: "AEgIS offline analysis developersers",
    value: "AEgIS offline analysis developersers",
  },
  {
    label: "AEgIS Shifts e-mailing list",
    value: "AEgIS Shifts e-mailing list",
  },
  {
    label: "AEgIS Simulations working group",
    value: "AEgIS Simulations working group",
  },
  {
    label: "AFP",
    value: "AFP",
  },
  {
    label: "African Conference on Fundamental and Applied Physics",
    value: "African Conference on Fundamental and Applied Physics",
  },
  {
    label: "African Strategy for Fundamental and Applied Physics",
    value: "African Strategy for Fundamental and Applied Physics",
  },
  {
    label: "AGFA  Advisory Team",
    value: "AGFA  Advisory Team",
  },
  {
    label: "AI Ethics",
    value: "AI Ethics",
  },
  {
    label: "AI Strategy",
    value: "AI Strategy",
  },
  {
    label: "AIDA WP15",
    value: "AIDA WP15",
  },
  {
    label: "AIDAinnova",
    value: "AIDAinnova",
  },
  {
    label: "AION",
    value: "AION",
  },
  {
    label: "Air quality monitoring",
    value: "Air quality monitoring",
  },
  {
    label: "AIS",
    value: "AIS",
  },
  {
    label: "AIS - Atlassian tools",
    value: "AIS - Atlassian tools",
  },
  {
    label: "AIS Data Warehouse",
    value: "AIS Data Warehouse",
  },
  {
    label: "ais-eb",
    value: "ais-eb",
  },
  {
    label: "AIS-GDI",
    value: "AIS-GDI",
  },
  {
    label: "AIS-HR",
    value: "AIS-HR",
  },
  {
    label: "AIS-MDS Business Objects Service",
    value: "AIS-MDS Business Objects Service",
  },
  {
    label: "AIS-PM",
    value: "AIS-PM",
  },
  {
    label: "AISB Infrastructure",
    value: "AISB Infrastructure",
  },
  {
    label: "AISBI Infrastructure",
    value: "AISBI Infrastructure",
  },
  {
    label: "AISDWH Infrastructure",
    value: "AISDWH Infrastructure",
  },
  {
    label: "aistls",
    value: "aistls",
  },
  {
    label: "Aladdin",
    value: "Aladdin",
  },
  {
    label: "ALca DB Shifts Phone",
    value: "ALca DB Shifts Phone",
  },
  {
    label: "ALEPH",
    value: "ALEPH",
  },
  {
    label: "ALICE - JAPAN Grid operations",
    value: "ALICE - JAPAN Grid operations",
  },
  {
    label: "ALICE 3",
    value: "ALICE 3",
  },
  {
    label: "ALICE ACORDE",
    value: "ALICE ACORDE",
  },
  {
    label: "ALICE analysis",
    value: "ALICE analysis",
  },
  {
    label: "ALICE analysis group on cosmic ray physics",
    value: "ALICE analysis group on cosmic ray physics",
  },
  {
    label: "ALICE authorised people to access CERN during Xmas closure",
    value: "ALICE authorised people to access CERN during Xmas closure",
  },
  {
    label: "ALICE Barrel tracking",
    value: "ALICE Barrel tracking",
  },
  {
    label: "ALICE Calibration",
    value: "ALICE Calibration",
  },
  {
    label: "ALICE CERN Team ",
    value: "ALICE CERN Team ",
  },
  {
    label: "ALICE China Group",
    value: "ALICE China Group",
  },
  {
    label: "ALICE CIAE Group",
    value: "ALICE CIAE Group",
  },
  {
    label: "ALICE Collaboration Database",
    value: "ALICE Collaboration Database",
  },
  {
    label: "ALICE Computing",
    value: "ALICE Computing",
  },
  {
    label: "ALICE Configuration Tool",
    value: "ALICE Configuration Tool",
  },
  {
    label: "ALICE cosmics",
    value: "ALICE cosmics",
  },
  {
    label: "ALICE CRU",
    value: "ALICE CRU",
  },
  {
    label: "ALICE D2H train operators",
    value: "ALICE D2H train operators",
  },
  {
    label: "ALICE DAQ",
    value: "ALICE DAQ",
  },
  {
    label: "ALICE data processing",
    value: "ALICE data processing",
  },
  {
    label: "ALICE DCDB system",
    value: "ALICE DCDB system",
  },
  {
    label: "ALICE DCS",
    value: "ALICE DCS",
  },
  {
    label: "ALICE DCS CPV alarms",
    value: "ALICE DCS CPV alarms",
  },
  {
    label: "ALICE DCS Oncall experts",
    value: "ALICE DCS Oncall experts",
  },
  {
    label: "ALICE Detectors Generic Forums",
    value: "ALICE Detectors Generic Forums",
  },
  {
    label: "ALICE DIMUON TRACKING",
    value: "ALICE DIMUON TRACKING",
  },
  {
    label: "ALICE DIMUON TRIGGER",
    value: "ALICE DIMUON TRIGGER",
  },
  {
    label: "ALICE DQM",
    value: "ALICE DQM",
  },
  {
    label: "Alice Editorial Board",
    value: "Alice Editorial Board",
  },
  {
    label: "ALICE Electronics",
    value: "ALICE Electronics",
  },
  {
    label: "ALICE EMCAL",
    value: "ALICE EMCAL",
  },
  {
    label: "ALICE EPN",
    value: "ALICE EPN",
  },
  {
    label: "ALICE Event Display",
    value: "ALICE Event Display",
  },
  {
    label: "ALICE finance",
    value: "ALICE finance",
  },
  {
    label: "ALICE FIT",
    value: "ALICE FIT",
  },
  {
    label: "ALICE FoCal",
    value: "ALICE FoCal",
  },
  {
    label: "ALICE FoCal engineering",
    value: "ALICE FoCal engineering",
  },
  {
    label: "ALICE GAS SYSTEMS",
    value: "ALICE GAS SYSTEMS",
  },
  {
    label: "ALICE Glance",
    value: "ALICE Glance",
  },
  {
    label: "ALICE grid operations",
    value: "ALICE grid operations",
  },
  {
    label: "Alice Grid Support",
    value: "Alice Grid Support",
  },
  {
    label: "ALICE HLT",
    value: "ALICE HLT",
  },
  {
    label: "ALICE HMPID",
    value: "ALICE HMPID",
  },
  {
    label: "ALICE HMPID coordination",
    value: "ALICE HMPID coordination",
  },
  {
    label: "ALICE HyperNews",
    value: "ALICE HyperNews",
  },
  {
    label: "ALICE India Admin Group",
    value: "ALICE India Admin Group",
  },
  {
    label: "alice india junior representative",
    value: "alice india junior representative",
  },
  {
    label: "Alice Indian seniors",
    value: "Alice Indian seniors",
  },
  {
    label: "ALICE Inventory Database",
    value: "ALICE Inventory Database",
  },
  {
    label: "ALICE ITS",
    value: "ALICE ITS",
  },
  {
    label: "ALICE ITS upgrade",
    value: "ALICE ITS upgrade",
  },
  {
    label: "ALICE ITS WP10",
    value: "ALICE ITS WP10",
  },
  {
    label: "ALICE Japan Tsukuba Team (General)",
    value: "ALICE Japan Tsukuba Team (General)",
  },
  {
    label: "ALICE Japan Tsukuba Team Analysis",
    value: "ALICE Japan Tsukuba Team Analysis",
  },
  {
    label: "ALICE junior representatives",
    value: "ALICE junior representatives",
  },
  {
    label: "Alice Juniors",
    value: "Alice Juniors",
  },
  {
    label: "ALICE JYFL",
    value: "ALICE JYFL",
  },
  {
    label: "ALICE Lund team",
    value: "ALICE Lund team",
  },
  {
    label: "ALICE management",
    value: "ALICE management",
  },
  {
    label: "ALICE MFT",
    value: "ALICE MFT",
  },
  {
    label: "ALICE Miscellaneous",
    value: "ALICE Miscellaneous",
  },
  {
    label: "ALICE Muon",
    value: "ALICE Muon",
  },
  {
    label: "ALICE O2",
    value: "ALICE O2",
  },
  {
    label: "ALICE O2 Software Release Coordination ",
    value: "ALICE O2 Software Release Coordination ",
  },
  {
    label: "ALICE O2 Technical coordination",
    value: "ALICE O2 Technical coordination",
  },
  {
    label: "ALICE O2FLP",
    value: "ALICE O2FLP",
  },
  {
    label: "ALICE Offline",
    value: "ALICE Offline",
  },
  {
    label: "ALICE ONLINE",
    value: "ALICE ONLINE",
  },
  {
    label: "ALICE Online Data Quality Monitoring",
    value: "ALICE Online Data Quality Monitoring",
  },
  {
    label: "Alice online support",
    value: "Alice online support",
  },
  {
    label: "ALICE Online Upgrade",
    value: "ALICE Online Upgrade",
  },
  {
    label: "ALICE Outreach",
    value: "ALICE Outreach",
  },
  {
    label: "ALICE PAG Azimuthal Correlations",
    value: "ALICE PAG Azimuthal Correlations",
  },
  {
    label: "ALICE PAG CF Femto",
    value: "ALICE PAG CF Femto",
  },
  {
    label: "ALICE PAG Flow",
    value: "ALICE PAG Flow",
  },
  {
    label: "ALICE Paper Drafts",
    value: "ALICE Paper Drafts",
  },
  {
    label: "ALICE PHOS",
    value: "ALICE PHOS",
  },
  {
    label: "ALICE PHOS cooling experts",
    value: "ALICE PHOS cooling experts",
  },
  {
    label: "ALICE PHOS offline commit",
    value: "ALICE PHOS offline commit",
  },
  {
    label: "ALICE Physics Analysis",
    value: "ALICE Physics Analysis",
  },
  {
    label: "ALICE PMD",
    value: "ALICE PMD",
  },
  {
    label: "ALICE Publication Committee",
    value: "ALICE Publication Committee",
  },
  {
    label: "ALICE PWG-GA train operators",
    value: "ALICE PWG-GA train operators",
  },
  {
    label: "ALICE PWGGA CaloTrackCorrelations Commit",
    value: "ALICE PWGGA CaloTrackCorrelations Commit",
  },
  {
    label: "ALICE QC",
    value: "ALICE QC",
  },
  {
    label: "ALICE RCT",
    value: "ALICE RCT",
  },
  {
    label: "ALICE Resonances analysis",
    value: "ALICE Resonances analysis",
  },
  {
    label: "ALICE Resources Coordination",
    value: "ALICE Resources Coordination",
  },
  {
    label: "ALICE review paper topical groups",
    value: "ALICE review paper topical groups",
  },
  {
    label: "ALICE Run Coordination",
    value: "ALICE Run Coordination",
  },
  {
    label: "ALICE SAFETY",
    value: "ALICE SAFETY",
  },
  {
    label: "ALICE SDD",
    value: "ALICE SDD",
  },
  {
    label: "ALICE SPD",
    value: "ALICE SPD",
  },
  {
    label: "ALICE Spokesperson",
    value: "ALICE Spokesperson",
  },
  {
    label: "ALICE statistical group",
    value: "ALICE statistical group",
  },
  {
    label: "ALICE T0",
    value: "ALICE T0",
  },
  {
    label: "ALICE team",
    value: "ALICE team",
  },
  {
    label: "ALICE Technical Board Internal Reviews",
    value: "ALICE Technical Board Internal Reviews",
  },
  {
    label: "ALICE Technical Board O2 Task Force",
    value: "ALICE Technical Board O2 Task Force",
  },
  {
    label: "ALICE Technical Coordination",
    value: "ALICE Technical Coordination",
  },
  {
    label: "ALICE TOF",
    value: "ALICE TOF",
  },
  {
    label: "ALICE TPC",
    value: "ALICE TPC",
  },
  {
    label: "ALICE TPC Electronics",
    value: "ALICE TPC Electronics",
  },
  {
    label: "ALICE TPC Front-End-Card Testing",
    value: "ALICE TPC Front-End-Card Testing",
  },
  {
    label: "ALICE TPC o2 software development",
    value: "ALICE TPC o2 software development",
  },
  {
    label: "ALICE TRD",
    value: "ALICE TRD",
  },
  {
    label: "ALICE TRD O2",
    value: "ALICE TRD O2",
  },
  {
    label: "ALICE TRD Particle Identification",
    value: "ALICE TRD Particle Identification",
  },
  {
    label: "ALICE trigger",
    value: "ALICE trigger",
  },
  {
    label: "ALICE upgrade",
    value: "ALICE upgrade",
  },
  {
    label: "ALICE Upgrade Physics",
    value: "ALICE Upgrade Physics",
  },
  {
    label: "ALICE visits",
    value: "ALICE visits",
  },
  {
    label: "Alice web access",
    value: "Alice web access",
  },
  {
    label: "ALICE Web Editors",
    value: "ALICE Web Editors",
  },
  {
    label: "ALICE Webmaster test roles",
    value: "ALICE Webmaster test roles",
  },
  {
    label: "ALICE Women",
    value: "ALICE Women",
  },
  {
    label: "ALICE WordPress Roles",
    value: "ALICE WordPress Roles",
  },
  {
    label: "ALICE Wuhan",
    value: "ALICE Wuhan",
  },
  {
    label: "alice-central-dcs",
    value: "alice-central-dcs",
  },
  {
    label: "ALICE-FIT software development",
    value: "ALICE-FIT software development",
  },
  {
    label: "alice-india-cb-members",
    value: "alice-india-cb-members",
  },
  {
    label: "ALICE-India-MB",
    value: "ALICE-India-MB",
  },
  {
    label: "alice-indian-senior-admin",
    value: "alice-indian-senior-admin",
  },
  {
    label: "ALICE-Japan",
    value: "ALICE-Japan",
  },
  {
    label: "ALICE-Japan-FoCal",
    value: "ALICE-Japan-FoCal",
  },
  {
    label: "ALICE-Korea",
    value: "ALICE-Korea",
  },
  {
    label: "alice-student-paper-discussion",
    value: "alice-student-paper-discussion",
  },
  {
    label: "ALICE-WUHAN",
    value: "ALICE-WUHAN",
  },
  {
    label: "ALICE3 InnerOuter Tracker",
    value: "ALICE3 InnerOuter Tracker",
  },
  {
    label: "ALICEOutreach",
    value: "ALICEOutreach",
  },
  {
    label: "Alignment  Calibration",
    value: "Alignment  Calibration",
  },
  {
    label: "All ALICE websyste notifiactions mails",
    value: "All ALICE websyste notifiactions mails",
  },
  {
    label: "All members IFCA",
    value: "All members IFCA",
  },
  {
    label: "ALPHA Experiment",
    value: "ALPHA Experiment",
  },
  {
    label: "ALPHA Metrology",
    value: "ALPHA Metrology",
  },
  {
    label: "ALPHA Social Media",
    value: "ALPHA Social Media",
  },
  {
    label: "ALPHA Website",
    value: "ALPHA Website",
  },
  {
    label: "alphasproject",
    value: "alphasproject",
  },
  {
    label: "alumni",
    value: "alumni",
  },
  {
    label: "AM ASIC",
    value: "AM ASIC",
  },
  {
    label: "AMBER",
    value: "AMBER",
  },
  {
    label: "AMBER - New QCD facility at SPS CERN",
    value: "AMBER - New QCD facility at SPS CERN",
  },
  {
    label: "AMBER IKAR TPC Safety System",
    value: "AMBER IKAR TPC Safety System",
  },
  {
    label: "AMBER kaon spectroscopy",
    value: "AMBER kaon spectroscopy",
  },
  {
    label: "AMS",
    value: "AMS",
  },
  {
    label: "AMS Alpha Analysis",
    value: "AMS Alpha Analysis",
  },
  {
    label: "AMS analysis of elementary particles",
    value: "AMS analysis of elementary particles",
  },
  {
    label: "AMS analysis working group",
    value: "AMS analysis working group",
  },
  {
    label: "AMS CR TRANSPORT",
    value: "AMS CR TRANSPORT",
  },
  {
    label: "AMS Data Shifts list",
    value: "AMS Data Shifts list",
  },
  {
    label: "AMS isotope analysis",
    value: "AMS isotope analysis",
  },
  {
    label: "AMS JMDC Software",
    value: "AMS JMDC Software",
  },
  {
    label: "AMS MIT group at CERN",
    value: "AMS MIT group at CERN",
  },
  {
    label: "AMS Photon Polarization Studies",
    value: "AMS Photon Polarization Studies",
  },
  {
    label: "AMS Production News",
    value: "AMS Production News",
  },
  {
    label: "AMS Production Shifts",
    value: "AMS Production Shifts",
  },
  {
    label: "ams soc harwdare",
    value: "ams soc harwdare",
  },
  {
    label: "AMS SOC Shift News",
    value: "AMS SOC Shift News",
  },
  {
    label: "AMS TRD Online",
    value: "AMS TRD Online",
  },
  {
    label: "ams unige machine learning group",
    value: "ams unige machine learning group",
  },
  {
    label: "AMS working group admins",
    value: "AMS working group admins",
  },
  {
    label: "AMS-02 eAss Software",
    value: "AMS-02 eAss Software",
  },
  {
    label: "AMS-Italy",
    value: "AMS-Italy",
  },
  {
    label: "AMS-Low energy studies",
    value: "AMS-Low energy studies",
  },
  {
    label: "AMS-Low energy studies admin",
    value: "AMS-Low energy studies admin",
  },
  {
    label: "AMVA4NewPhysics",
    value: "AMVA4NewPhysics",
  },
  {
    label: "Analysis",
    value: "Analysis",
  },
  {
    label: "Analysis Preservation",
    value: "Analysis Preservation",
  },
  {
    label: "AnalysisQA",
    value: "AnalysisQA",
  },
  {
    label: "Analyzing using XAMPP",
    value: "Analyzing using XAMPP",
  },
  {
    label: "Ankara University",
    value: "Ankara University",
  },
  {
    label: "Antimatter Factory",
    value: "Antimatter Factory",
  },
  {
    label: "ANUBIS",
    value: "ANUBIS",
  },
  {
    label: "APC section support group",
    value: "APC section support group",
  },
  {
    label: "APPEC Technology Forum",
    value: "APPEC Technology Forum",
  },
  {
    label: "Apple software distribution",
    value: "Apple software distribution",
  },
  {
    label: "Application Provisioning",
    value: "Application Provisioning",
  },
  {
    label: "approval",
    value: "approval",
  },
  {
    label: "APT AIS Roles groups",
    value: "APT AIS Roles groups",
  },
  {
    label: "APT EVM HLLHC",
    value: "APT EVM HLLHC",
  },
  {
    label: "Archive",
    value: "Archive",
  },
  {
    label: "ARCON",
    value: "ARCON",
  },
  {
    label: "Argus Authorization Service",
    value: "Argus Authorization Service",
  },
  {
    label: "ARIES",
    value: "ARIES",
  },
  {
    label: "Arts-CERN mailing list",
    value: "Arts-CERN mailing list",
  },
  {
    label: "ASACUA",
    value: "ASACUA",
  },
  {
    label: "ASACUSA",
    value: "ASACUSA",
  },
  {
    label: "ASACUSA EPC",
    value: "ASACUSA EPC",
  },
  {
    label: "ASACUSA Management Board",
    value: "ASACUSA Management Board",
  },
  {
    label: "ASACUSA PTB ",
    value: "ASACUSA PTB ",
  },
  {
    label: "ASD",
    value: "ASD",
  },
  {
    label: "ASIC support GIT",
    value: "ASIC support GIT",
  },
  {
    label: "ASIC Support Service",
    value: "ASIC Support Service",
  },
  {
    label: "ASIC technology and design",
    value: "ASIC technology and design",
  },
  {
    label: "ASM-EA-admin",
    value: "ASM-EA-admin",
  },
  {
    label: "Asset and Maintenance Management",
    value: "Asset and Maintenance Management",
  },
  {
    label: "Astroparticle physics",
    value: "Astroparticle physics",
  },
  {
    label: "ATRAP",
    value: "ATRAP",
  },
  {
    label: "ATS",
    value: "ATS",
  },
  {
    label: "ATLAS Physics",
    value: "ATLAS Physics",
  },
  {
    label: "ATLAS Detectors",
    value: "ATLAS Detectors",
  },
  {
    label: "ATLAS Software & Computing",
    value: "ATLAS Software & Computing",
  },
  {
    label: "ATLAS TDAQ",
    value: "ATLAS TDAQ",
  },
  {
    label: "ATLAS Trigger",
    value: "ATLAS Trigger",
  },
  {
    label: "ATLAS Run Operations",
    value: "ATLAS Run Operations",
  },
  {
    label: "ATLAS Data Preparation",
    value: "ATLAS Data Preparation",
  },
  {
    label: "ATLAS Management",
    value: "ATLAS Management",
  },
  {
    label: "attendees of the 3rd DPHEP workshop",
    value: "attendees of the 3rd DPHEP workshop",
  },
  {
    label: "ATTRACT",
    value: "ATTRACT",
  },
  {
    label: "Audit",
    value: "Audit",
  },
  {
    label: "Authoring",
    value: "Authoring",
  },
  {
    label: "Authorization Service",
    value: "Authorization Service",
  },
  {
    label: "Availability Studies",
    value: "Availability Studies",
  },
  {
    label: "AWAKE",
    value: "AWAKE",
  },
  {
    label: "B180 SC Magnet Test Facility",
    value: "B180 SC Magnet Test Facility",
  },
  {
    label: "BaBar Analysis Review",
    value: "BaBar Analysis Review",
  },
  {
    label: "BaBar member egroup",
    value: "BaBar member egroup",
  },
  {
    label: "batch",
    value: "batch",
  },
  {
    label: "Batch Fillup Tenant",
    value: "Batch Fillup Tenant",
  },
  {
    label: "bbantoob",
    value: "bbantoob",
  },
  {
    label: "BBQ",
    value: "BBQ",
  },
  {
    label: "BC Shinyproxy",
    value: "BC Shinyproxy",
  },
  {
    label: "BCR and BS management - administration",
    value: "BCR and BS management - administration",
  },
  {
    label: "BCR and BS management - list of distribution",
    value: "BCR and BS management - list of distribution",
  },
  {
    label: "BDF",
    value: "BDF",
  },
  {
    label: "Bdg 311 test benches facility",
    value: "Bdg 311 test benches facility",
  },
  {
    label: "BE ACC-VPC 2016",
    value: "BE ACC-VPC 2016",
  },
  {
    label: "BE Controls Group",
    value: "BE Controls Group",
  },
  {
    label: "BE Department",
    value: "BE Department",
  },
  {
    label: "BE Industrial Control",
    value: "BE Industrial Control",
  },
  {
    label: "BE OP eLogbook",
    value: "BE OP eLogbook",
  },
  {
    label: "BE Project",
    value: "BE Project",
  },
  {
    label: "BE-ABP",
    value: "BE-ABP",
  },
  {
    label: "BE-ABP-HSC",
    value: "BE-ABP-HSC",
  },
  {
    label: "BE-ABP-HSL",
    value: "BE-ABP-HSL",
  },
  {
    label: "BE-ABP-SU Geode users",
    value: "BE-ABP-SU Geode users",
  },
  {
    label: "BE-BI DIDT development group",
    value: "BE-BI DIDT development group",
  },
  {
    label: "BE-BI Project",
    value: "BE-BI Project",
  },
  {
    label: "BE-BI-BGC",
    value: "BE-BI-BGC",
  },
  {
    label: "BE-BI-BGI",
    value: "BE-BI-BGI",
  },
  {
    label: "BE-BI-EA-CERN-Members",
    value: "BE-BI-EA-CERN-Members",
  },
  {
    label: "BE-BI-LHC",
    value: "BE-BI-LHC",
  },
  {
    label: "BE-CEM",
    value: "BE-CEM",
  },
  {
    label: "BE-CEM-MRO Robotics",
    value: "BE-CEM-MRO Robotics",
  },
  {
    label: "BE-CO TRACING",
    value: "BE-CO TRACING",
  },
  {
    label: "BE-CO-FE InstallationMaintenance",
    value: "BE-CO-FE InstallationMaintenance",
  },
  {
    label: "BE-CO-HT continuous integration",
    value: "BE-CO-HT continuous integration",
  },
  {
    label: "BE-CO-IN",
    value: "BE-CO-IN",
  },
  {
    label: "BE-CSS",
    value: "BE-CSS",
  },
  {
    label: "be-dep-ea-scada-expert",
    value: "be-dep-ea-scada-expert",
  },
  {
    label: "be-dep-ea-scada-viewer",
    value: "be-dep-ea-scada-viewer",
  },
  {
    label: "BE-Dep-Members Overtime",
    value: "BE-Dep-Members Overtime",
  },
  {
    label: "be-dep-tso",
    value: "be-dep-tso",
  },
  {
    label: "BE-EA",
    value: "BE-EA",
  },
  {
    label: "BE-EA-Snow",
    value: "BE-EA-Snow",
  },
  {
    label: "BE-ICS",
    value: "BE-ICS",
  },
  {
    label: "BE-ICS-AP",
    value: "BE-ICS-AP",
  },
  {
    label: "BE-ICS-CE",
    value: "BE-ICS-CE",
  },
  {
    label: "BE-ICS-PCS",
    value: "BE-ICS-PCS",
  },
  {
    label: "be-ics-snow-support-lines",
    value: "be-ics-snow-support-lines",
  },
  {
    label: "BE-OP",
    value: "BE-OP",
  },
  {
    label: "BE-OP-AD",
    value: "BE-OP-AD",
  },
  {
    label: "BE-RF Group",
    value: "BE-RF Group",
  },
  {
    label: "BE-RF-CS FESA developers",
    value: "BE-RF-CS FESA developers",
  },
  {
    label: "Beam coupling impedance",
    value: "Beam coupling impedance",
  },
  {
    label: "Beam Dump Facility (BDF)",
    value: "Beam Dump Facility (BDF)",
  },
  {
    label: "Beam Dynamics Meeting",
    value: "Beam Dynamics Meeting",
  },
  {
    label: "Beam Instrumentation",
    value: "Beam Instrumentation",
  },
  {
    label: "beam-beam and luminosity meeting",
    value: "beam-beam and luminosity meeting",
  },
  {
    label: "beam-beam meeting",
    value: "beam-beam meeting",
  },
  {
    label: "beam-beam workshop",
    value: "beam-beam workshop",
  },
  {
    label: "beam-beam workshop chairpersons",
    value: "beam-beam workshop chairpersons",
  },
  {
    label: "Beam-induced heat load Task Force",
    value: "Beam-induced heat load Task Force",
  },
  {
    label: "Beamline for schools",
    value: "Beamline for schools",
  },
  {
    label: "Beams Geodetric Metrology",
    value: "Beams Geodetric Metrology",
  },
  {
    label: "beamtest2023",
    value: "beamtest2023",
  },
  {
    label: "beer",
    value: "beer",
  },
  {
    label: "Belgium cern users",
    value: "Belgium cern users",
  },
  {
    label: "Benchmark",
    value: "Benchmark",
  },
  {
    label: "betastar options at IP2",
    value: "betastar options at IP2",
  },
  {
    label: "BI LHC Planning E-group",
    value: "BI LHC Planning E-group",
  },
  {
    label: "BI Python Expert GUIs",
    value: "BI Python Expert GUIs",
  },
  {
    label: "BI-LHC",
    value: "BI-LHC",
  },
  {
    label: "Biennial African School on Fundamental Physics and its Appl.",
    value: "Biennial African School on Fundamental Physics and its Appl.",
  },
  {
    label: "BIGNet",
    value: "BIGNet",
  },
  {
    label: "BioDynaMo",
    value: "BioDynaMo",
  },
  {
    label: "BLM ",
    value: "BLM ",
  },
  {
    label: "Bluegriffon",
    value: "Bluegriffon",
  },
  {
    label: "BOOST IAC",
    value: "BOOST IAC",
  },
  {
    label: "Box of Pandora",
    value: "Box of Pandora",
  },
  {
    label: "BPH Workshop 2021",
    value: "BPH Workshop 2021",
  },
  {
    label: "BRIL Run Coordination",
    value: "BRIL Run Coordination",
  },
  {
    label: "BST project diffusion list",
    value: "BST project diffusion list",
  },
  {
    label: "BTE desktop support",
    value: "BTE desktop support",
  },
  {
    label: "Building 368 users",
    value: "Building 368 users",
  },
  {
    label: "Buisness Objects",
    value: "Buisness Objects",
  },
  {
    label: "Business Computing",
    value: "Business Computing",
  },
  {
    label: "Business Continuity Disaster Recovery",
    value: "Business Continuity Disaster Recovery",
  },
  {
    label: "C216 Members for ELCO",
    value: "C216 Members for ELCO",
  },
  {
    label: "Cable Ageing Research",
    value: "Cable Ageing Research",
  },
  {
    label: "Cabling",
    value: "Cabling",
  },
  {
    label: "CAD",
    value: "CAD",
  },
  {
    label: "CAD Exchange",
    value: "CAD Exchange",
  },
  {
    label: "CAD exchange for CAST collaboration",
    value: "CAD exchange for CAST collaboration",
  },
  {
    label: "CAD Support",
    value: "CAD Support",
  },
  {
    label: "CAD Teams",
    value: "CAD Teams",
  },
  {
    label: "CAD-leaders",
    value: "CAD-leaders",
  },
  {
    label: "CAEC",
    value: "CAEC",
  },
  {
    label: "CAiMIRA",
    value: "CAiMIRA",
  },
  {
    label: "CALICE",
    value: "CALICE",
  },
  {
    label: "CALICE BT",
    value: "CALICE BT",
  },
  {
    label: "CALICE SDHCAL",
    value: "CALICE SDHCAL",
  },
  {
    label: "CALICE SiW-ECAL",
    value: "CALICE SiW-ECAL",
  },
  {
    label: "CALICE Speakers Bureau",
    value: "CALICE Speakers Bureau",
  },
  {
    label: "CALICE-DAQ",
    value: "CALICE-DAQ",
  },
  {
    label: "CALIIMAX",
    value: "CALIIMAX",
  },
  {
    label: "Calorimeters for the FCChh experiment",
    value: "Calorimeters for the FCChh experiment",
  },
  {
    label: "CAM",
    value: "CAM",
  },
  {
    label: "Cambridge HEP group",
    value: "Cambridge HEP group",
  },
  {
    label: "CARE Project",
    value: "CARE Project",
  },
  {
    label: "CAS",
    value: "CAS",
  },
  {
    label: "CAST",
    value: "CAST",
  },
  {
    label: "CAT ITK",
    value: "CAT ITK",
  },
  {
    label: "CBM",
    value: "CBM",
  },
  {
    label: "CCT",
    value: "CCT",
  },
  {
    label: "CENF",
    value: "CENF",
  },
  {
    label: "CENF neutrino engineering group",
    value: "CENF neutrino engineering group",
  },
  {
    label: "CEPC",
    value: "CEPC",
  },
  {
    label: "CERN ACCELERATOR SCHOOL",
    value: "CERN ACCELERATOR SCHOOL",
  },
  {
    label: "CERN Amateur Radio Club",
    value: "CERN Amateur Radio Club",
  },
  {
    label: "CERN ASIC SUPPORT",
    value: "CERN ASIC SUPPORT",
  },
  {
    label: "CERN Authoring",
    value: "CERN Authoring",
  },
  {
    label: "CERN Automobile Club",
    value: "CERN Automobile Club",
  },
  {
    label: "CERN Basketball Club",
    value: "CERN Basketball Club",
  },
  {
    label: "CERN Beam Instrumentation",
    value: "CERN Beam Instrumentation",
  },
  {
    label: "CERN Business Computing",
    value: "CERN Business Computing",
  },
  {
    label: "CERN Choir Club",
    value: "CERN Choir Club",
  },
  {
    label: "CERN CLUBS",
    value: "CERN CLUBS",
  },
  {
    label: "CERN COUNCIL EUROPEAN STRATEGY",
    value: "CERN COUNCIL EUROPEAN STRATEGY",
  },
  {
    label: "CERN Croquet Club All Members",
    value: "CERN Croquet Club All Members",
  },
  {
    label: "CERN Dancing Club",
    value: "CERN Dancing Club",
  },
  {
    label: "CERN Diving Club",
    value: "CERN Diving Club",
  },
  {
    label: "CERN Document Server administrators",
    value: "CERN Document Server administrators",
  },
  {
    label: "CERN Document Server team",
    value: "CERN Document Server team",
  },
  {
    label: "CERN Education",
    value: "CERN Education",
  },
  {
    label: "CERN Electrical Networks SCADA",
    value: "CERN Electrical Networks SCADA",
  },
  {
    label: "CERN Filmmakers club",
    value: "CERN Filmmakers club",
  },
  {
    label: "CERN Finance Club",
    value: "CERN Finance Club",
  },
  {
    label: "CERN Fitness Club",
    value: "CERN Fitness Club",
  },
  {
    label: "CERN Football club",
    value: "CERN Football club",
  },
  {
    label: "CERN Ideasquare",
    value: "CERN Ideasquare",
  },
  {
    label: "CERN Legal Service",
    value: "CERN Legal Service",
  },
  {
    label: "CERN Medical Applications Study Group",
    value: "CERN Medical Applications Study Group",
  },
  {
    label: "CERN Mobile Applications",
    value: "CERN Mobile Applications",
  },
  {
    label: "CERN Music Club",
    value: "CERN Music Club",
  },
  {
    label: "CERN Ombud",
    value: "CERN Ombud",
  },
  {
    label: "CERN openlab",
    value: "CERN openlab",
  },
  {
    label: "CERN Orienteering club",
    value: "CERN Orienteering club",
  },
  {
    label: "CERN protocol office",
    value: "CERN protocol office",
  },
  {
    label: "cern relay race",
    value: "cern relay race",
  },
  {
    label: "CERN Rugby Club",
    value: "CERN Rugby Club",
  },
  {
    label: "CERN Rugby School",
    value: "CERN Rugby School",
  },
  {
    label: "CERN Running Club",
    value: "CERN Running Club",
  },
  {
    label: "CERN School of Computing",
    value: "CERN School of Computing",
  },
  {
    label: "cern service catalogue",
    value: "cern service catalogue",
  },
  {
    label: "CERN Ski Club",
    value: "CERN Ski Club",
  },
  {
    label: "CERN Solar Club",
    value: "CERN Solar Club",
  },
  {
    label: "CERN Standardisation Committee",
    value: "CERN Standardisation Committee",
  },
  {
    label: "CERN Stores",
    value: "CERN Stores",
  },
  {
    label: "CERN Stores Operations",
    value: "CERN Stores Operations",
  },
  {
    label: "CERN Stores Replenishment",
    value: "CERN Stores Replenishment",
  },
  {
    label: "CERN Stores Serrurerie",
    value: "CERN Stores Serrurerie",
  },
  {
    label: "CERN Subaqua Club Secretariat",
    value: "CERN Subaqua Club Secretariat",
  },
  {
    label: "CERN Tape Archive software",
    value: "CERN Tape Archive software",
  },
  {
    label: "CERN Team in experiment",
    value: "CERN Team in experiment",
  },
  {
    label: "CERN Training",
    value: "CERN Training",
  },
  {
    label: "CERN TT club Committee",
    value: "CERN TT club Committee",
  },
  {
    label: "CERN Volleyball Club",
    value: "CERN Volleyball Club",
  },
  {
    label: "CERN Vray",
    value: "CERN Vray",
  },
  {
    label: "CERN Webfest mailing list ",
    value: "CERN Webfest mailing list ",
  },
  {
    label: "CERN-CZ",
    value: "CERN-CZ",
  },
  {
    label: "CERN-Eco-Actions-club",
    value: "CERN-Eco-Actions-club",
  },
  {
    label: "CERN-IPMC",
    value: "CERN-IPMC",
  },
  {
    label: "CERN-PROD",
    value: "CERN-PROD",
  },
  {
    label: "CERN360",
    value: "CERN360",
  },
  {
    label: "CERN60",
    value: "CERN60",
  },
  {
    label: "CERN70",
    value: "CERN70",
  },
  {
    label: "CERNBox cryogenic group administration",
    value: "CERNBox cryogenic group administration",
  },
  {
    label: "CERNBox Service",
    value: "CERNBox Service",
  },
  {
    label: "CERNGreece  Industry  daymarch 31 2014",
    value: "CERNGreece  Industry  daymarch 31 2014",
  },
  {
    label: "CERNGreekWorkingGroup",
    value: "CERNGreekWorkingGroup",
  },
  {
    label: "cernlib community port maintainers",
    value: "cernlib community port maintainers",
  },
  {
    label: "CERNPhone e-group",
    value: "CERNPhone e-group",
  },
  {
    label: "CernVM",
    value: "CernVM",
  },
  {
    label: "CernVM Workshops Administrators",
    value: "CernVM Workshops Administrators",
  },
  {
    label: "CERT Computer Security",
    value: "CERT Computer Security",
  },
  {
    label: "Certification Authority",
    value: "Certification Authority",
  },
  {
    label: "CGN VIPs",
    value: "CGN VIPs",
  },
  {
    label: "Characterization of APTS OPAMP for ITS3",
    value: "Characterization of APTS OPAMP for ITS3",
  },
  {
    label: "CHARM",
    value: "CHARM",
  },
  {
    label: "CHARM Apps",
    value: "CHARM Apps",
  },
  {
    label: "CHEP conference list admin group",
    value: "CHEP conference list admin group",
  },
  {
    label: "Children Activities",
    value: "Children Activities",
  },
  {
    label: "CHIS",
    value: "CHIS",
  },
  {
    label: "CI user for Front-End Software",
    value: "CI user for Front-End Software",
  },
  {
    label: "CI4FPGA",
    value: "CI4FPGA",
  },
  {
    label: "CineGlobe Festival",
    value: "CineGlobe Festival",
  },
  {
    label: "Civil engineering",
    value: "Civil engineering",
  },
  {
    label: "CIXP",
    value: "CIXP",
  },
  {
    label: "Cleaning",
    value: "Cleaning",
  },
  {
    label: "CLEAR",
    value: "CLEAR",
  },
  {
    label: "CLEAR-VESPER",
    value: "CLEAR-VESPER",
  },
  {
    label: "CLIC CTC",
    value: "CLIC CTC",
  },
  {
    label: "CLIC High Gradient Tests",
    value: "CLIC High Gradient Tests",
  },
  {
    label: "CLIC PiP",
    value: "CLIC PiP",
  },
  {
    label: "CLIC Post-Collision Line and Dumps",
    value: "CLIC Post-Collision Line and Dumps",
  },
  {
    label: "Climbing",
    value: "Climbing",
  },
  {
    label: "CLOUD",
    value: "CLOUD",
  },
  {
    label: "CLOUD collaboration",
    value: "CLOUD collaboration",
  },
  {
    label: "Cloud Infrastructure",
    value: "Cloud Infrastructure",
  },
  {
    label: "CLOUD ITN",
    value: "CLOUD ITN",
  },
  {
    label: "CLOUD Paper optin",
    value: "CLOUD Paper optin",
  },
  {
    label: "cloudman",
    value: "cloudman",
  },
  {
    label: "Club - Climbing",
    value: "Club - Climbing",
  },
  {
    label: "Club - Dancing",
    value: "Club - Dancing",
  },
  {
    label: "Club - Frisbee",
    value: "Club - Frisbee",
  },
  {
    label: "Club - IdeaCircle",
    value: "Club - IdeaCircle",
  },
  {
    label: "Club - LCMC",
    value: "Club - LCMC",
  },
  {
    label: "Club - Mafia",
    value: "Club - Mafia",
  },
  {
    label: "Club - Martial Arts",
    value: "Club - Martial Arts",
  },
  {
    label: "Club - Micro Club",
    value: "Club - Micro Club",
  },
  {
    label: "Club - Muslims",
    value: "Club - Muslims",
  },
  {
    label: "Club - Scuba",
    value: "Club - Scuba",
  },
  {
    label: "Club - Snooker",
    value: "Club - Snooker",
  },
  {
    label: "Club - Softball",
    value: "Club - Softball",
  },
  {
    label: "club - squash",
    value: "club - squash",
  },
  {
    label: "Club - Yoga",
    value: "Club - Yoga",
  },
  {
    label: "Club Martial Arts",
    value: "Club Martial Arts",
  },
  {
    label: "club sports",
    value: "club sports",
  },
  {
    label: "Club Student Activities",
    value: "Club Student Activities",
  },
  {
    label: "Club-Canoe-Kayak",
    value: "Club-Canoe-Kayak",
  },
  {
    label: "Club-Cricket",
    value: "Club-Cricket",
  },
  {
    label: "club-football",
    value: "club-football",
  },
  {
    label: "Club-games",
    value: "Club-games",
  },
  {
    label: "club-ski",
    value: "club-ski",
  },
  {
    label: "Club-Velo",
    value: "Club-Velo",
  },
  {
    label: "Club-YCC",
    value: "Club-YCC",
  },
  {
    label: "Clubs",
    value: "Clubs",
  },
  {
    label: "Cluster configuration (puppet)",
    value: "Cluster configuration (puppet)",
  },
  {
    label: "Cmake",
    value: "Cmake",
  },
  {
    label: "CMS",
    value: "CMS",
  },
  {
    label: "CMS - Gas Electron Multipliers",
    value: "CMS - Gas Electron Multipliers",
  },
  {
    label: "CMS - GEM DB",
    value: "CMS - GEM DB",
  },
  {
    label: "CMS - Run Control ",
    value: "CMS - Run Control ",
  },
  {
    label: "CMS - Test",
    value: "CMS - Test",
  },
  {
    label: "CMS -- Test Beam Planning ",
    value: "CMS -- Test Beam Planning ",
  },
  {
    label: "CMS -- US-CMS Detector Upgrades",
    value: "CMS -- US-CMS Detector Upgrades",
  },
  {
    label: "CMS against covid-19",
    value: "CMS against covid-19",
  },
  {
    label: "CMS AlCa O2O workflows",
    value: "CMS AlCa O2O workflows",
  },
  {
    label: "CMS AlCaDB Monitoring Nagvis",
    value: "CMS AlCaDB Monitoring Nagvis",
  },
  {
    label: "CMS Alignment",
    value: "CMS Alignment",
  },
  {
    label: "CMS Alignment  Calibration",
    value: "CMS Alignment  Calibration",
  },
  {
    label: "CMS Analysis Preservation",
    value: "CMS Analysis Preservation",
  },
  {
    label: "CMS Austria",
    value: "CMS Austria",
  },
  {
    label: "CMS automatic background production",
    value: "CMS automatic background production",
  },
  {
    label: "CMS B-Physics and Quarkonia steering group",
    value: "CMS B-Physics and Quarkonia steering group",
  },
  {
    label: "CMS B2G",
    value: "CMS B2G",
  },
  {
    label: "CMS Brazil",
    value: "CMS Brazil",
  },
  {
    label: "CMS BRIL",
    value: "CMS BRIL",
  },
  {
    label: "CMS BRIL Phase 2 Upgrade",
    value: "CMS BRIL Phase 2 Upgrade",
  },
  {
    label: "CMS Camera users",
    value: "CMS Camera users",
  },
  {
    label: "CMS CB Chair Team",
    value: "CMS CB Chair Team",
  },
  {
    label: "CMS CB Committees",
    value: "CMS CB Committees",
  },
  {
    label: "CMS CB Sub-Group",
    value: "CMS CB Sub-Group",
  },
  {
    label: "CMS central DCS",
    value: "CMS central DCS",
  },
  {
    label: "CMS CERNT3 EOS Access Management",
    value: "CMS CERNT3 EOS Access Management",
  },
  {
    label: "CMS Charged Higgs",
    value: "CMS Charged Higgs",
  },
  {
    label: "CMS China",
    value: "CMS China",
  },
  {
    label: "CMS China Winter Camp",
    value: "CMS China Winter Camp",
  },
  {
    label: "CMS Commissioning",
    value: "CMS Commissioning",
  },
  {
    label: "CMS Committees",
    value: "CMS Committees",
  },
  {
    label: "CMS CompOps",
    value: "CMS CompOps",
  },
  {
    label: "CMS Computing",
    value: "CMS Computing",
  },
  {
    label: "CMS Computing Security",
    value: "CMS Computing Security",
  },
  {
    label: "CMS condition dropbox",
    value: "CMS condition dropbox",
  },
  {
    label: "CMS Conditions",
    value: "CMS Conditions",
  },
  {
    label: "CMS Conference Committee",
    value: "CMS Conference Committee",
  },
  {
    label: "CMS cooling",
    value: "CMS cooling",
  },
  {
    label: "CMS CSC on call team",
    value: "CMS CSC on call team",
  },
  {
    label: "CMS DAQ",
    value: "CMS DAQ",
  },
  {
    label: "CMS DAQ Phase2",
    value: "CMS DAQ Phase2",
  },
  {
    label: "CMS Data Analysis Schools",
    value: "CMS Data Analysis Schools",
  },
  {
    label: "CMS Data Certification Experts",
    value: "CMS Data Certification Experts",
  },
  {
    label: "CMS data preservation",
    value: "CMS data preservation",
  },
  {
    label: "cms data transfers",
    value: "cms data transfers",
  },
  {
    label: "CMS databases",
    value: "CMS databases",
  },
  {
    label: "CMS DCS",
    value: "CMS DCS",
  },
  {
    label: "CMS DCS Developers Training",
    value: "CMS DCS Developers Training",
  },
  {
    label: "CMS DCS Expert operations",
    value: "CMS DCS Expert operations",
  },
  {
    label: "CMS Displaced Vertices",
    value: "CMS Displaced Vertices",
  },
  {
    label: "CMS Diversity and Inclusion",
    value: "CMS Diversity and Inclusion",
  },
  {
    label: "CMS Diversity Monitoring Oversight Committee",
    value: "CMS Diversity Monitoring Oversight Committee",
  },
  {
    label: "CMS DocDB",
    value: "CMS DocDB",
  },
  {
    label: "CMS DPG",
    value: "CMS DPG",
  },
  {
    label: "CMS DQM Conveners",
    value: "CMS DQM Conveners",
  },
  {
    label: "CMS DQM Data Certification Team",
    value: "CMS DQM Data Certification Team",
  },
  {
    label: "CMS DQM Developers Team",
    value: "CMS DQM Developers Team",
  },
  {
    label: "CMS DQM Experts",
    value: "CMS DQM Experts",
  },
  {
    label: "CMS DQM GUI support",
    value: "CMS DQM GUI support",
  },
  {
    label: "CMS DQM ML relevant",
    value: "CMS DQM ML relevant",
  },
  {
    label: "CMS DQM On-Call Team",
    value: "CMS DQM On-Call Team",
  },
  {
    label: "CMS DQM Operations Team",
    value: "CMS DQM Operations Team",
  },
  {
    label: "CMS DQM Shift",
    value: "CMS DQM Shift",
  },
  {
    label: "CMS Drift Tubes Operation",
    value: "CMS Drift Tubes Operation",
  },
  {
    label: "CMS DT OMS developers group",
    value: "CMS DT OMS developers group",
  },
  {
    label: "CMS DT Oncall (Doc)",
    value: "CMS DT Oncall (Doc)",
  },
  {
    label: "CMS DTIC management body",
    value: "CMS DTIC management body",
  },
  {
    label: "CMS EAM",
    value: "CMS EAM",
  },
  {
    label: "CMS ECAL",
    value: "CMS ECAL",
  },
  {
    label: "CMS ECAL calibration",
    value: "CMS ECAL calibration",
  },
  {
    label: "CMS ECAL DB",
    value: "CMS ECAL DB",
  },
  {
    label: "CMS ECAL DCS",
    value: "CMS ECAL DCS",
  },
  {
    label: "CMS ECAL Detector Control System",
    value: "CMS ECAL Detector Control System",
  },
  {
    label: "CMS ECAL Internal scrutiny group",
    value: "CMS ECAL Internal scrutiny group",
  },
  {
    label: "CMS ECAL Italy",
    value: "CMS ECAL Italy",
  },
  {
    label: "CMS ECAL Operations Management",
    value: "CMS ECAL Operations Management",
  },
  {
    label: "CMS ECAL Trigger",
    value: "CMS ECAL Trigger",
  },
  {
    label: "CMS Ecuador",
    value: "CMS Ecuador",
  },
  {
    label: "CMS Electronics",
    value: "CMS Electronics",
  },
  {
    label: "CMS Endcap Muon",
    value: "CMS Endcap Muon",
  },
  {
    label: "CMS Endcap Timing Layer",
    value: "CMS Endcap Timing Layer",
  },
  {
    label: "CMS Engagement Office",
    value: "CMS Engagement Office",
  },
  {
    label: "CMS EOS",
    value: "CMS EOS",
  },
  {
    label: "CMS EOS Group Space Management",
    value: "CMS EOS Group Space Management",
  },
  {
    label: "CMS EWK W extraction activities ",
    value: "CMS EWK W extraction activities ",
  },
  {
    label: "CMS EXO",
    value: "CMS EXO",
  },
  {
    label: "CMS Exotica",
    value: "CMS Exotica",
  },
  {
    label: "CMS Exotica Hotline",
    value: "CMS Exotica Hotline",
  },
  {
    label: "CMS Facilities and Services",
    value: "CMS Facilities and Services",
  },
  {
    label: "CMS four top quarks analysis",
    value: "CMS four top quarks analysis",
  },
  {
    label: "CMS FSC",
    value: "CMS FSC",
  },
  {
    label: "CMS FullSim",
    value: "CMS FullSim",
  },
  {
    label: "CMS GAS SYSTEM",
    value: "CMS GAS SYSTEM",
  },
  {
    label: "CMS GEM",
    value: "CMS GEM",
  },
  {
    label: "CMS GEM Coordination Meeting List",
    value: "CMS GEM Coordination Meeting List",
  },
  {
    label: "CMS GEM Detector Production and RD",
    value: "CMS GEM Detector Production and RD",
  },
  {
    label: "CMS Generator Coordination",
    value: "CMS Generator Coordination",
  },
  {
    label: "CMS Ghent Group",
    value: "CMS Ghent Group",
  },
  {
    label: "CMS Glance Tests",
    value: "CMS Glance Tests",
  },
  {
    label: "CMS hadronic charged higgs",
    value: "CMS hadronic charged higgs",
  },
  {
    label: "CMS HCAL",
    value: "CMS HCAL",
  },
  {
    label: "CMS HCAL DB",
    value: "CMS HCAL DB",
  },
  {
    label: "CMS Heavy Ion",
    value: "CMS Heavy Ion",
  },
  {
    label: "CMS Heavy Ion Coordination",
    value: "CMS Heavy Ion Coordination",
  },
  {
    label: "CMS HEPHY group",
    value: "CMS HEPHY group",
  },
  {
    label: "CMS HGCal",
    value: "CMS HGCal",
  },
  {
    label: "CMS HGCAL Backend Electronics",
    value: "CMS HGCAL Backend Electronics",
  },
  {
    label: "CMS HGCAL databases",
    value: "CMS HGCAL databases",
  },
  {
    label: "CMS HGCAL Module Assembly Centers",
    value: "CMS HGCAL Module Assembly Centers",
  },
  {
    label: "CMS Higgs",
    value: "CMS Higgs",
  },
  {
    label: "CMS Higgs Exotic",
    value: "CMS Higgs Exotic",
  },
  {
    label: "CMS Higgs to tautau CP in decay analysis",
    value: "CMS Higgs to tautau CP in decay analysis",
  },
  {
    label: "CMS High Granularity Calorimeter",
    value: "CMS High Granularity Calorimeter",
  },
  {
    label: "CMS India",
    value: "CMS India",
  },
  {
    label: "CMS Institute Group",
    value: "CMS Institute Group",
  },
  {
    label: "CMS Integration",
    value: "CMS Integration",
  },
  {
    label: "CMS Internal Communications",
    value: "CMS Internal Communications",
  },
  {
    label: "CMS Istanbul Data",
    value: "CMS Istanbul Data",
  },
  {
    label: "CMS Italia",
    value: "CMS Italia",
  },
  {
    label: "CMS Italy",
    value: "CMS Italy",
  },
  {
    label: "CMS Jet MET activities",
    value: "CMS Jet MET activities",
  },
  {
    label: "CMS K-State group",
    value: "CMS K-State group",
  },
  {
    label: "CMS Korea GEM RD",
    value: "CMS Korea GEM RD",
  },
  {
    label: "CMS Korea MTD",
    value: "CMS Korea MTD",
  },
  {
    label: "CMS L1 Phase-2 Muon Algorithms",
    value: "CMS L1 Phase-2 Muon Algorithms",
  },
  {
    label: "CMS L1 Trigger",
    value: "CMS L1 Trigger",
  },
  {
    label: "CMS Latinamerican Institutions",
    value: "CMS Latinamerican Institutions",
  },
  {
    label: "CMS llg",
    value: "CMS llg",
  },
  {
    label: "CMS LUM",
    value: "CMS LUM",
  },
  {
    label: "cms lumi op notification",
    value: "cms lumi op notification",
  },
  {
    label: "CMS machine learning",
    value: "CMS machine learning",
  },
  {
    label: "CMS management",
    value: "CMS management",
  },
  {
    label: "CMS Matrix element and Future Generators",
    value: "CMS Matrix element and Future Generators",
  },
  {
    label: "CMS MET Run2 legacy paper",
    value: "CMS MET Run2 legacy paper",
  },
  {
    label: "CMS MIT cluster administration",
    value: "CMS MIT cluster administration",
  },
  {
    label: "CMS Monitoring",
    value: "CMS Monitoring",
  },
  {
    label: "CMS MTD",
    value: "CMS MTD",
  },
  {
    label: "CMS MTD DCS",
    value: "CMS MTD DCS",
  },
  {
    label: "CMS MUON",
    value: "CMS MUON",
  },
  {
    label: "CMS Muon institute reps",
    value: "CMS Muon institute reps",
  },
  {
    label: "CMS MUON RUN COORDINATORS",
    value: "CMS MUON RUN COORDINATORS",
  },
  {
    label: "CMS MVA Working Group",
    value: "CMS MVA Working Group",
  },
  {
    label: "CMS National",
    value: "CMS National",
  },
  {
    label: "CMS Neutron and Radiation Monitors (Run 3 and PHASE2)",
    value: "CMS Neutron and Radiation Monitors (Run 3 and PHASE2)",
  },
  {
    label: "CMS NPS",
    value: "CMS NPS",
  },
  {
    label: "CMS Offline Computing Upgrade SW",
    value: "CMS Offline Computing Upgrade SW",
  },
  {
    label: "CMS Offline DB experts",
    value: "CMS Offline DB experts",
  },
  {
    label: "CMS Offline Run Managers Shifters",
    value: "CMS Offline Run Managers Shifters",
  },
  {
    label: "CMS OMS",
    value: "CMS OMS",
  },
  {
    label: "CMS Onia Acceptance study",
    value: "CMS Onia Acceptance study",
  },
  {
    label: "CMS Online Camera Owners",
    value: "CMS Online Camera Owners",
  },
  {
    label: "CMS online DB experts",
    value: "CMS online DB experts",
  },
  {
    label: "CMS Online Software",
    value: "CMS Online Software",
  },
  {
    label: "CMS Opportunistic Workflows",
    value: "CMS Opportunistic Workflows",
  },
  {
    label: "CMS Other  States B group",
    value: "CMS Other  States B group",
  },
  {
    label: "CMS Other Non-Member States group",
    value: "CMS Other Non-Member States group",
  },
  {
    label: "CMS Outreach",
    value: "CMS Outreach",
  },
  {
    label: "CMS Particle Flow",
    value: "CMS Particle Flow",
  },
  {
    label: "CMS PAT Tutorial",
    value: "CMS PAT Tutorial",
  },
  {
    label: "CMS PCL Monitoring",
    value: "CMS PCL Monitoring",
  },
  {
    label: "CMS PF Operations Management",
    value: "CMS PF Operations Management",
  },
  {
    label: "CMS Phase II Endcap Calorimeters",
    value: "CMS Phase II Endcap Calorimeters",
  },
  {
    label: "CMS Phase2 L1 Muon Subsystem",
    value: "CMS Phase2 L1 Muon Subsystem",
  },
  {
    label: "CMS phase2 tracker power",
    value: "CMS phase2 tracker power",
  },
  {
    label: "CMS physics",
    value: "CMS physics",
  },
  {
    label: "CMS physics office",
    value: "CMS physics office",
  },
  {
    label: "CMS Pileup Jet ID",
    value: "CMS Pileup Jet ID",
  },
  {
    label: "CMS PPD Conveners",
    value: "CMS PPD Conveners",
  },
  {
    label: "CMS Precision Proton Spectrometer",
    value: "CMS Precision Proton Spectrometer",
  },
  {
    label: "CMS Production Managers",
    value: "CMS Production Managers",
  },
  {
    label: "CMS PubComm",
    value: "CMS PubComm",
  },
  {
    label: "CMS Publication Committee",
    value: "CMS Publication Committee",
  },
  {
    label: "CMS PUPPI ML working group",
    value: "CMS PUPPI ML working group",
  },
  {
    label: "CMS Quartic Gauge Coupling Analysis (W-gamma-gamma)",
    value: "CMS Quartic Gauge Coupling Analysis (W-gamma-gamma)",
  },
  {
    label: "CMS r4s test board develop",
    value: "CMS r4s test board develop",
  },
  {
    label: "CMS RPC",
    value: "CMS RPC",
  },
  {
    label: "CMS RPC nominations committee",
    value: "CMS RPC nominations committee",
  },
  {
    label: "CMS Run Coordination",
    value: "CMS Run Coordination",
  },
  {
    label: "CMS Run Field Managers 2018",
    value: "CMS Run Field Managers 2018",
  },
  {
    label: "CMS Single Top",
    value: "CMS Single Top",
  },
  {
    label: "CMS Single top polarization",
    value: "CMS Single top polarization",
  },
  {
    label: "CMS SMP",
    value: "CMS SMP",
  },
  {
    label: "CMS SMP-V",
    value: "CMS SMP-V",
  },
  {
    label: "CMS SNT group",
    value: "CMS SNT group",
  },
  {
    label: "CMS SNU",
    value: "CMS SNU",
  },
  {
    label: "CMS STEAM Validation Team",
    value: "CMS STEAM Validation Team",
  },
  {
    label: "CMS Storage Manager Alerting Group",
    value: "CMS Storage Manager Alerting Group",
  },
  {
    label: "CMS Summer Students 2009",
    value: "CMS Summer Students 2009",
  },
  {
    label: "CMS Survey",
    value: "CMS Survey",
  },
  {
    label: "CMS SUS",
    value: "CMS SUS",
  },
  {
    label: "CMS SUSY",
    value: "CMS SUSY",
  },
  {
    label: "CMS SUSY with Displaced Vertices and Jets",
    value: "CMS SUSY with Displaced Vertices and Jets",
  },
  {
    label: "CMS Tamu",
    value: "CMS Tamu",
  },
  {
    label: "CMS Tau Commisioning",
    value: "CMS Tau Commisioning",
  },
  {
    label: "CMS TAU POG",
    value: "CMS TAU POG",
  },
  {
    label: "CMS TC",
    value: "CMS TC",
  },
  {
    label: "CMS TCDS",
    value: "CMS TCDS",
  },
  {
    label: "CMS TCDS2",
    value: "CMS TCDS2",
  },
  {
    label: "CMS Thesis Award Committee",
    value: "CMS Thesis Award Committee",
  },
  {
    label: "CMS Thesis Award Committee 2020-2021",
    value: "CMS Thesis Award Committee 2020-2021",
  },
  {
    label: "CMS Thesis Award Committee members 2021-2022",
    value: "CMS Thesis Award Committee members 2021-2022",
  },
  {
    label: "cms TIF users",
    value: "cms TIF users",
  },
  {
    label: "CMS TK Ph2 Managers",
    value: "CMS TK Ph2 Managers",
  },
  {
    label: "CMS Top Ohysics",
    value: "CMS Top Ohysics",
  },
  {
    label: "CMS Top Physics",
    value: "CMS Top Physics",
  },
  {
    label: "CMS Top XSec Analysis Groups",
    value: "CMS Top XSec Analysis Groups",
  },
  {
    label: "CMS TOTEM",
    value: "CMS TOTEM",
  },
  {
    label: "CMS Tracker",
    value: "CMS Tracker",
  },
  {
    label: "CMS tracker alignment",
    value: "CMS tracker alignment",
  },
  {
    label: "CMS Tracker databases",
    value: "CMS Tracker databases",
  },
  {
    label: "CMS Tracker DB",
    value: "CMS Tracker DB",
  },
  {
    label: "CMS Tracker DCS",
    value: "CMS Tracker DCS",
  },
  {
    label: "CMS Tracker Safety System tests",
    value: "CMS Tracker Safety System tests",
  },
  {
    label: "CMS Tracker Upgrade",
    value: "CMS Tracker Upgrade",
  },
  {
    label: "CMS Tracking",
    value: "CMS Tracking",
  },
  {
    label: "CMS Trigger",
    value: "CMS Trigger",
  },
  {
    label: "CMS Trigger Studies Group",
    value: "CMS Trigger Studies Group",
  },
  {
    label: "CMS UC Davis ",
    value: "CMS UC Davis ",
  },
  {
    label: "CMS UK",
    value: "CMS UK",
  },
  {
    label: "CMS Upgrade",
    value: "CMS Upgrade",
  },
  {
    label: "CMS Upgrade Performance Studies",
    value: "CMS Upgrade Performance Studies",
  },
  {
    label: "CMS US",
    value: "CMS US",
  },
  {
    label: "CMS User Support",
    value: "CMS User Support",
  },
  {
    label: "cms visits",
    value: "cms visits",
  },
  {
    label: "CMS WBM",
    value: "CMS WBM",
  },
  {
    label: "CMS Wisconsin Trigger On-Call List",
    value: "CMS Wisconsin Trigger On-Call List",
  },
  {
    label: "CMS Yildiz Group ",
    value: "CMS Yildiz Group ",
  },
  {
    label: "CMS-Antares group",
    value: "CMS-Antares group",
  },
  {
    label: "CMS-BPH-sin2b",
    value: "CMS-BPH-sin2b",
  },
  {
    label: "CMS-BRIL",
    value: "CMS-BRIL",
  },
  {
    label: "CMS-CMSDCS Group",
    value: "CMS-CMSDCS Group",
  },
  {
    label: "CMS-cmsonline-group",
    value: "CMS-cmsonline-group",
  },
  {
    label: "CMS-COMP-DEVS",
    value: "CMS-COMP-DEVS",
  },
  {
    label: "CMS-DAQ",
    value: "CMS-DAQ",
  },
  {
    label: "CMS-HO",
    value: "CMS-HO",
  },
  {
    label: "cms-oms",
    value: "cms-oms",
  },
  {
    label: "CMS-Pixel",
    value: "CMS-Pixel",
  },
  {
    label: "CMS-Pixel-Upgrade",
    value: "CMS-Pixel-Upgrade",
  },
  {
    label: "CMS-shiftlist-group",
    value: "CMS-shiftlist-group",
  },
  {
    label: "CMS-shiftlist-group-admins",
    value: "CMS-shiftlist-group-admins",
  },
  {
    label: "CMS-Totem",
    value: "CMS-Totem",
  },
  {
    label: "CMS-Upgrade PII-Comprehensive Review-Tracker",
    value: "CMS-Upgrade PII-Comprehensive Review-Tracker",
  },
  {
    label: "CMSDTOrganisationatP5",
    value: "CMSDTOrganisationatP5",
  },
  {
    label: "cmsp5 hostgroup",
    value: "cmsp5 hostgroup",
  },
  {
    label: "CMSRPCIB",
    value: "CMSRPCIB",
  },
  {
    label: "CNID - Institutional Board",
    value: "CNID - Institutional Board",
  },
  {
    label: "CNID Steering Group",
    value: "CNID Steering Group",
  },
  {
    label: "Co-Authoring",
    value: "Co-Authoring",
  },
  {
    label: "CO2 cooling",
    value: "CO2 cooling",
  },
  {
    label: "CO2 systems on-call team e-group",
    value: "CO2 systems on-call team e-group",
  },
  {
    label: "Coder Modernisation and Performance Working Group",
    value: "Coder Modernisation and Performance Working Group",
  },
  {
    label: "codex-b",
    value: "codex-b",
  },
  {
    label: "Coffee",
    value: "Coffee",
  },
  {
    label: "COFI School",
    value: "COFI School",
  },
  {
    label: "COLDEX experiment",
    value: "COLDEX experiment",
  },
  {
    label: "Collaboration Board",
    value: "Collaboration Board",
  },
  {
    label: "Collimation Hardware",
    value: "Collimation Hardware",
  },
  {
    label: "collimator software",
    value: "collimator software",
  },
  {
    label: "COMETA",
    value: "COMETA",
  },
  {
    label: "Common Technologies",
    value: "Common Technologies",
  },
  {
    label: "Communication",
    value: "Communication",
  },
  {
    label: "CompactLight",
    value: "CompactLight",
  },
  {
    label: "compass",
    value: "compass",
  },
  {
    label: "COMPASS DAQ",
    value: "COMPASS DAQ",
  },
  {
    label: "COMPASS DCS eGroups",
    value: "COMPASS DCS eGroups",
  },
  {
    label: "COMPASS Detector Experts",
    value: "COMPASS Detector Experts",
  },
  {
    label: "Computing Documentation and AnnouncementsComputing Docum...",
    value: "Computing Documentation and AnnouncementsComputing Docum...",
  },
  {
    label: "Computing Facilities",
    value: "Computing Facilities",
  },
  {
    label: "Computing Groups",
    value: "Computing Groups",
  },
  {
    label: "comte",
    value: "comte",
  },
  {
    label: "conf organisation",
    value: "conf organisation",
  },
  {
    label: "Conferences  Workshops",
    value: "Conferences  Workshops",
  },
  {
    label: "Conferences and Workshops",
    value: "Conferences and Workshops",
  },
  {
    label: "confluence",
    value: "confluence",
  },
  {
    label: "Contacts for the CMS UPG Group",
    value: "Contacts for the CMS UPG Group",
  },
  {
    label: "Control Data Analytics",
    value: "Control Data Analytics",
  },
  {
    label: "Controls Operational Software e-group",
    value: "Controls Operational Software e-group",
  },
  {
    label: "Conveners for the proposal of an INFRADEV project for the Mu",
    value: "Conveners for the proposal of an INFRADEV project for the Mu",
  },
  {
    label: "Coordinateurs des commissions AP",
    value: "Coordinateurs des commissions AP",
  },
  {
    label: "Coordination",
    value: "Coordination",
  },
  {
    label: "Coordination LS2 CRG",
    value: "Coordination LS2 CRG",
  },
  {
    label: "Corona-Virus-Task-Force",
    value: "Corona-Virus-Task-Force",
  },
  {
    label: "COSINUS Dark Matter",
    value: "COSINUS Dark Matter",
  },
  {
    label: "cosmic",
    value: "cosmic",
  },
  {
    label: "Council bodies",
    value: "Council bodies",
  },
  {
    label: "Coverity",
    value: "Coverity",
  },
  {
    label: "COVID-19",
    value: "COVID-19",
  },
  {
    label: "CPOD",
    value: "CPOD",
  },
  {
    label: "Crab Cavities",
    value: "Crab Cavities",
  },
  {
    label: "Crab Cavities Failure Studies",
    value: "Crab Cavities Failure Studies",
  },
  {
    label: "Crab Cavity Technical Coordination Working Group",
    value: "Crab Cavity Technical Coordination Working Group",
  },
  {
    label: "Crane maintenance",
    value: "Crane maintenance",
  },
  {
    label: "CRESST Dark Matter",
    value: "CRESST Dark Matter",
  },
  {
    label: "CRG Analytics",
    value: "CRG Analytics",
  },
  {
    label: "CRG DB coordination",
    value: "CRG DB coordination",
  },
  {
    label: "CRG GROUP CODING OFFICER",
    value: "CRG GROUP CODING OFFICER",
  },
  {
    label: "CRG GROUP INFORMATION MANAGENT OFFICER",
    value: "CRG GROUP INFORMATION MANAGENT OFFICER",
  },
  {
    label: "CRG LOGBOOKS",
    value: "CRG LOGBOOKS",
  },
  {
    label: "CRG OLD STRUCTURE",
    value: "CRG OLD STRUCTURE",
  },
  {
    label: "CRG TEST",
    value: "CRG TEST",
  },
  {
    label: "CRG-MAINTENANCE",
    value: "CRG-MAINTENANCE",
  },
  {
    label: "crg-staff",
    value: "crg-staff",
  },
  {
    label: "CRIC",
    value: "CRIC",
  },
  {
    label: "crilin-calo",
    value: "crilin-calo",
  },
  {
    label: "Crisis Management",
    value: "Crisis Management",
  },
  {
    label: "CRISP",
    value: "CRISP",
  },
  {
    label: "CROME",
    value: "CROME",
  },
  {
    label: "Cryo Maintenance Office",
    value: "Cryo Maintenance Office",
  },
  {
    label: "cryo team",
    value: "cryo team",
  },
  {
    label: "Cryocluster",
    value: "Cryocluster",
  },
  {
    label: "CRYOCLUSTER dark matter",
    value: "CRYOCLUSTER dark matter",
  },
  {
    label: "Cryogenic for FCC",
    value: "Cryogenic for FCC",
  },
  {
    label: "Cryogenic Instrumentation",
    value: "Cryogenic Instrumentation",
  },
  {
    label: "Cryogenic Laboratoy",
    value: "Cryogenic Laboratoy",
  },
  {
    label: "Cryogenic Management",
    value: "Cryogenic Management",
  },
  {
    label: "cryogenic methods",
    value: "cryogenic methods",
  },
  {
    label: "cryogenic operation",
    value: "cryogenic operation",
  },
  {
    label: "cryogenic Operation  maintenance",
    value: "cryogenic Operation  maintenance",
  },
  {
    label: "Cryogenics",
    value: "Cryogenics",
  },
  {
    label: "Cryogenics Control",
    value: "Cryogenics Control",
  },
  {
    label: "Cryogenics operated by TE-CRG-ML",
    value: "Cryogenics operated by TE-CRG-ML",
  },
  {
    label: "cryogenics seminar",
    value: "cryogenics seminar",
  },
  {
    label: "Cryogenics-group cernbox management",
    value: "Cryogenics-group cernbox management",
  },
  {
    label: "crystal channeling in medical accelerators",
    value: "crystal channeling in medical accelerators",
  },
  {
    label: "CS3 Cloud Services for Synchronisation and Sharing",
    value: "CS3 Cloud Services for Synchronisation and Sharing",
  },
  {
    label: "cs4od",
    value: "cs4od",
  },
  {
    label: "CSAM",
    value: "CSAM",
  },
  {
    label: "CSC",
    value: "CSC",
  },
  {
    label: "cse serco employes",
    value: "cse serco employes",
  },
  {
    label: "CST simulations",
    value: "CST simulations",
  },
  {
    label: "CSTSC",
    value: "CSTSC",
  },
  {
    label: "CT-PPS",
    value: "CT-PPS",
  },
  {
    label: "CTA",
    value: "CTA",
  },
  {
    label: "CTA LST",
    value: "CTA LST",
  },
  {
    label: "CTA SST-1M data and physics analysis group",
    value: "CTA SST-1M data and physics analysis group",
  },
  {
    label: "CTA-LST",
    value: "CTA-LST",
  },
  {
    label: "CTF3",
    value: "CTF3",
  },
  {
    label: "CTMC club (models club)",
    value: "CTMC club (models club)",
  },
  {
    label: "CTP from Emte organization",
    value: "CTP from Emte organization",
  },
  {
    label: "CTTB",
    value: "CTTB",
  },
  {
    label: "CTU Evaporative cooling group",
    value: "CTU Evaporative cooling group",
  },
  {
    label: "CU Physics in Films",
    value: "CU Physics in Films",
  },
  {
    label: "Cultural Physics Awareness Book",
    value: "Cultural Physics Awareness Book",
  },
  {
    label: "Current S307 team",
    value: "Current S307 team",
  },
  {
    label: "Custom-works-in-EN-ACE",
    value: "Custom-works-in-EN-ACE",
  },
  {
    label: "CVC",
    value: "CVC",
  },
  {
    label: "CWFC2012",
    value: "CWFC2012",
  },
  {
    label: "cyrille.vuillemincea.fr",
    value: "cyrille.vuillemincea.fr",
  },
  {
    label: "DAMPE Geneva",
    value: "DAMPE Geneva",
  },
  {
    label: "DAMPE Production",
    value: "DAMPE Production",
  },
  {
    label: "DAMPE Software",
    value: "DAMPE Software",
  },
  {
    label: "DAMPE-STK Europe",
    value: "DAMPE-STK Europe",
  },
  {
    label: "Danish community",
    value: "Danish community",
  },
  {
    label: "DAQ ",
    value: "DAQ ",
  },
  {
    label: "Dark Interactions Workshops",
    value: "Dark Interactions Workshops",
  },
  {
    label: "DARK simulation",
    value: "DARK simulation",
  },
  {
    label: "DARK TEC",
    value: "DARK TEC",
  },
  {
    label: "darkmachines",
    value: "darkmachines",
  },
  {
    label: "DarkSector4mu",
    value: "DarkSector4mu",
  },
  {
    label: "Data Analysis",
    value: "Data Analysis",
  },
  {
    label: "Data Analytics As A Service",
    value: "Data Analytics As A Service",
  },
  {
    label: "Data Centre Installations",
    value: "Data Centre Installations",
  },
  {
    label: "Data centre repairs",
    value: "Data centre repairs",
  },
  {
    label: "Data compilation",
    value: "Data compilation",
  },
  {
    label: "Data Privacy Protection",
    value: "Data Privacy Protection",
  },
  {
    label: "Data Science at High Energy Physics",
    value: "Data Science at High Energy Physics",
  },
  {
    label: "Data Storage",
    value: "Data Storage",
  },
  {
    label: "Data Visualization",
    value: "Data Visualization",
  },
  {
    label: "Database Services",
    value: "Database Services",
  },
  {
    label: "DataCentreAccess",
    value: "DataCentreAccess",
  },
  {
    label: "DB On Demand",
    value: "DB On Demand",
  },
  {
    label: "DCS",
    value: "DCS",
  },
  {
    label: "DELPHI",
    value: "DELPHI",
  },
  {
    label: "Delphi experiment webmasters",
    value: "Delphi experiment webmasters",
  },
  {
    label: "Departure Formalities",
    value: "Departure Formalities",
  },
  {
    label: "Deployment of new RTT code.",
    value: "Deployment of new RTT code.",
  },
  {
    label: "Design Office Activity Management ",
    value: "Design Office Activity Management ",
  },
  {
    label: "Design System",
    value: "Design System",
  },
  {
    label: "DESY Top Z",
    value: "DESY Top Z",
  },
  {
    label: "Detector Cooling",
    value: "Detector Cooling",
  },
  {
    label: "Detector Cooling Supervision",
    value: "Detector Cooling Supervision",
  },
  {
    label: "Detector RD",
    value: "Detector RD",
  },
  {
    label: "Detector Technology",
    value: "Detector Technology",
  },
  {
    label: "DetectorCoolingPrimaryCO2",
    value: "DetectorCoolingPrimaryCO2",
  },
  {
    label: "DevelopersCERN",
    value: "DevelopersCERN",
  },
  {
    label: "Development of sonar measurement",
    value: "Development of sonar measurement",
  },
  {
    label: "Development of SRF RD ideas",
    value: "Development of SRF RD ideas",
  },
  {
    label: "developpers of madgraph",
    value: "developpers of madgraph",
  },
  {
    label: "DFS Hosted Webserver management e-groups",
    value: "DFS Hosted Webserver management e-groups",
  },
  {
    label: "DFT Simulations",
    value: "DFT Simulations",
  },
  {
    label: "DG Safety officers",
    value: "DG Safety officers",
  },
  {
    label: "DG Unit",
    value: "DG Unit",
  },
  {
    label: "Diamon Alarms (LASER) Service Data Management",
    value: "Diamon Alarms (LASER) Service Data Management",
  },
  {
    label: "DIC",
    value: "DIC",
  },
  {
    label: "Digital Libraries",
    value: "Digital Libraries",
  },
  {
    label: "DIR - data integration and reporting",
    value: "DIR - data integration and reporting",
  },
  {
    label: "DIS2018",
    value: "DIS2018",
  },
  {
    label: "Discussions on Particle Tracking Codes",
    value: "Discussions on Particle Tracking Codes",
  },
  {
    label: "Distributed computing",
    value: "Distributed computing",
  },
  {
    label: "Diversity",
    value: "Diversity",
  },
  {
    label: "Diversity and Inclusion Officers",
    value: "Diversity and Inclusion Officers",
  },
  {
    label: "Diversity-Informal-Networks",
    value: "Diversity-Informal-Networks",
  },
  {
    label: "Documents",
    value: "Documents",
  },
  {
    label: "doors-installation-maintenance",
    value: "doors-installation-maintenance",
  },
  {
    label: "DPHEP",
    value: "DPHEP",
  },
  {
    label: "Dragonboating",
    value: "Dragonboating",
  },
  {
    label: "DRD",
    value: "DRD",
  },
  {
    label: "DRD Calo - Calorimeter RD",
    value: "DRD Calo - Calorimeter RD",
  },
  {
    label: "DRD1 - Gaseous Detector RD",
    value: "DRD1 - Gaseous Detector RD",
  },
  {
    label: "DRD1 spokespersons and CB chair",
    value: "DRD1 spokespersons and CB chair",
  },
  {
    label: "DRD1 WP Funding Agency Contact Persons",
    value: "DRD1 WP Funding Agency Contact Persons",
  },
  {
    label: "DRD1 WP3 - Straw Work Package",
    value: "DRD1 WP3 - Straw Work Package",
  },
  {
    label: "DRD1 WP3 Project B (Straws in Hadron Physics Application)",
    value: "DRD1 WP3 Project B (Straws in Hadron Physics Application)",
  },
  {
    label: "drd1-wp8",
    value: "drd1-wp8",
  },
  {
    label: "DRD2",
    value: "DRD2",
  },
  {
    label: "drd3",
    value: "drd3",
  },
  {
    label: "DRD3 - Solid State Detector RD",
    value: "DRD3 - Solid State Detector RD",
  },
  {
    label: "DRD4",
    value: "DRD4",
  },
  {
    label: "DRD4 - Photon Detector RD",
    value: "DRD4 - Photon Detector RD",
  },
  {
    label: "DRD5",
    value: "DRD5",
  },
  {
    label: "DRD6 - Calorimeter RD",
    value: "DRD6 - Calorimeter RD",
  },
  {
    label: "DRD7 Project egroup",
    value: "DRD7 Project egroup",
  },
  {
    label: "DRDCalo-Institute",
    value: "DRDCalo-Institute",
  },
  {
    label: "Drupal",
    value: "Drupal",
  },
  {
    label: "Drupal editing permissions",
    value: "Drupal editing permissions",
  },
  {
    label: "Drupal editing team",
    value: "Drupal editing team",
  },
  {
    label: "Drupal editing team SEE Group",
    value: "Drupal editing team SEE Group",
  },
  {
    label: "Drupal Editors for the FAP website",
    value: "Drupal Editors for the FAP website",
  },
  {
    label: "Drupal full editing permissions team",
    value: "Drupal full editing permissions team",
  },
  {
    label: "Drupal full permissions",
    value: "Drupal full permissions",
  },
  {
    label: "Drupal Hosted Infrastructure management e-groups",
    value: "Drupal Hosted Infrastructure management e-groups",
  },
  {
    label: "Drupal test",
    value: "Drupal test",
  },
  {
    label: "DSS",
    value: "DSS",
  },
  {
    label: "DsTau",
    value: "DsTau",
  },
  {
    label: "DT-DI",
    value: "DT-DI",
  },
  {
    label: "DT-DI OpenStack group",
    value: "DT-DI OpenStack group",
  },
  {
    label: "dual-readout calorimetry for future accelerators",
    value: "dual-readout calorimetry for future accelerators",
  },
  {
    label: "DUNE",
    value: "DUNE",
  },
  {
    label: "dune-solar",
    value: "dune-solar",
  },
  {
    label: "DUNE-UK",
    value: "DUNE-UK",
  },
  {
    label: "Dutch visits",
    value: "Dutch visits",
  },
  {
    label: "e-bidding",
    value: "e-bidding",
  },
  {
    label: "e-contract",
    value: "e-contract",
  },
  {
    label: "e-group admins",
    value: "e-group admins",
  },
  {
    label: "e-group for members of the CMS DFC",
    value: "e-group for members of the CMS DFC",
  },
  {
    label: "E-JADE",
    value: "E-JADE",
  },
  {
    label: "e-learning",
    value: "e-learning",
  },
  {
    label: "E2A",
    value: "E2A",
  },
  {
    label: "EA Renovation Project",
    value: "EA Renovation Project",
  },
  {
    label: "EA-gas",
    value: "EA-gas",
  },
  {
    label: "EASITrain",
    value: "EASITrain",
  },
  {
    label: "East Area",
    value: "East Area",
  },
  {
    label: "EATM",
    value: "EATM",
  },
  {
    label: "EBTS",
    value: "EBTS",
  },
  {
    label: "ecc",
    value: "ecc",
  },
  {
    label: "ECFA",
    value: "ECFA",
  },
  {
    label: "ECFA ECR prize committee",
    value: "ECFA ECR prize committee",
  },
  {
    label: "ECFA Roadmap ",
    value: "ECFA Roadmap ",
  },
  {
    label: "ECFA-Roadmap-DRD4-members",
    value: "ECFA-Roadmap-DRD4-members",
  },
  {
    label: "ECR management - administration",
    value: "ECR management - administration",
  },
  {
    label: "ECR management - lists for distribution",
    value: "ECR management - lists for distribution",
  },
  {
    label: "eda users",
    value: "eda users",
  },
  {
    label: "EDH Access",
    value: "EDH Access",
  },
  {
    label: "EDH Pools",
    value: "EDH Pools",
  },
  {
    label: "edh-access",
    value: "edh-access",
  },
  {
    label: "EDH-SHARE",
    value: "EDH-SHARE",
  },
  {
    label: "EDH-SHARE-RECR-DYNAMIC",
    value: "EDH-SHARE-RECR-DYNAMIC",
  },
  {
    label: "EDIT2011",
    value: "EDIT2011",
  },
  {
    label: "EDM",
    value: "EDM",
  },
  {
    label: "EDMS",
    value: "EDMS",
  },
  {
    label: "EDMS-MTF",
    value: "EDMS-MTF",
  },
  {
    label: "EDR",
    value: "EDR",
  },
  {
    label: "Education",
    value: "Education",
  },
  {
    label: "EduRoam",
    value: "EduRoam",
  },
  {
    label: "Efficiency Think Tank",
    value: "Efficiency Think Tank",
  },
  {
    label: "eFiles",
    value: "eFiles",
  },
  {
    label: "EFT",
    value: "EFT",
  },
  {
    label: "EGEE-security",
    value: "EGEE-security",
  },
  {
    label: "Egypt Membership",
    value: "Egypt Membership",
  },
  {
    label: "Egypt-CRERN",
    value: "Egypt-CRERN",
  },
  {
    label: "Egyptian outreach project",
    value: "Egyptian outreach project",
  },
  {
    label: "EIC",
    value: "EIC",
  },
  {
    label: "Einstein Telescope",
    value: "Einstein Telescope",
  },
  {
    label: "EIROforum",
    value: "EIROforum",
  },
  {
    label: "Elasticsearch",
    value: "Elasticsearch",
  },
  {
    label: "ELEC committee",
    value: "ELEC committee",
  },
  {
    label: "Electrical Engineering",
    value: "Electrical Engineering",
  },
  {
    label: "Electron cloud studies",
    value: "Electron cloud studies",
  },
  {
    label: "Electron Cooler",
    value: "Electron Cooler",
  },
  {
    label: "Electronics",
    value: "Electronics",
  },
  {
    label: "ELENA",
    value: "ELENA",
  },
  {
    label: "ELG Cernbox",
    value: "ELG Cernbox",
  },
  {
    label: "Elg gateway",
    value: "Elg gateway",
  },
  {
    label: "EMI",
    value: "EMI",
  },
  {
    label: "Emu",
    value: "Emu",
  },
  {
    label: "EN Department",
    value: "EN Department",
  },
  {
    label: "EN organigrams",
    value: "EN organigrams",
  },
  {
    label: "EN-AA",
    value: "EN-AA",
  },
  {
    label: "en-aa-snow-support-lines",
    value: "en-aa-snow-support-lines",
  },
  {
    label: "EN-ACE",
    value: "EN-ACE",
  },
  {
    label: "EN-ACE-OSS",
    value: "EN-ACE-OSS",
  },
  {
    label: "EN-ACE-website",
    value: "EN-ACE-website",
  },
  {
    label: "EN-Cathi",
    value: "EN-Cathi",
  },
  {
    label: "EN-CV",
    value: "EN-CV",
  },
  {
    label: "EN-CV CAMMS",
    value: "EN-CV CAMMS",
  },
  {
    label: "EN-CV CDD",
    value: "EN-CV CDD",
  },
  {
    label: "EN-CV Store",
    value: "EN-CV Store",
  },
  {
    label: "EN-CV-CES",
    value: "EN-CV-CES",
  },
  {
    label: "EN-CV-CL",
    value: "EN-CV-CL",
  },
  {
    label: "EN-CV-DOW",
    value: "EN-CV-DOW",
  },
  {
    label: "EN-CV-ODM",
    value: "EN-CV-ODM",
  },
  {
    label: "EN-CV-OP",
    value: "EN-CV-OP",
  },
  {
    label: "EN-CV-PJ",
    value: "EN-CV-PJ",
  },
  {
    label: "EN-EL",
    value: "EN-EL",
  },
  {
    label: "EN-EL IED Management",
    value: "EN-EL IED Management",
  },
  {
    label: "EN-EL Logbook feed",
    value: "EN-EL Logbook feed",
  },
  {
    label: "EN-EL SCADA",
    value: "EN-EL SCADA",
  },
  {
    label: "EN-EL SCADA Data Concentrators",
    value: "EN-EL SCADA Data Concentrators",
  },
  {
    label: "EN-EL SCADA GUI",
    value: "EN-EL SCADA GUI",
  },
  {
    label: "EN-EL UPS Management",
    value: "EN-EL UPS Management",
  },
  {
    label: "EN-EL Web",
    value: "EN-EL Web",
  },
  {
    label: "EN-EL-BLACK-LIST",
    value: "EN-EL-BLACK-LIST",
  },
  {
    label: "EN-EL-CO-ENSDM",
    value: "EN-EL-CO-ENSDM",
  },
  {
    label: "EN-EL-CO-PIQUET",
    value: "EN-EL-CO-PIQUET",
  },
  {
    label: "EN-EL-SUPPORT",
    value: "EN-EL-SUPPORT",
  },
  {
    label: "EN-ELSTOCKMANAGEMENT",
    value: "EN-ELSTOCKMANAGEMENT",
  },
  {
    label: "EN-HE",
    value: "EN-HE",
  },
  {
    label: "EN-HE Design office",
    value: "EN-HE Design office",
  },
  {
    label: "EN-HE ODM",
    value: "EN-HE ODM",
  },
  {
    label: "EN-HE-HEM",
    value: "EN-HE-HEM",
  },
  {
    label: "EN-HE-HM",
    value: "EN-HE-HM",
  },
  {
    label: "EN-HE-LM",
    value: "EN-HE-LM",
  },
  {
    label: "EN-ICE",
    value: "EN-ICE",
  },
  {
    label: "EN-ICE-PLC",
    value: "EN-ICE-PLC",
  },
  {
    label: "EN-ICE-PROJECTS",
    value: "EN-ICE-PROJECTS",
  },
  {
    label: "EN-ICE-SCD",
    value: "EN-ICE-SCD",
  },
  {
    label: "EN-ICE-SIC",
    value: "EN-ICE-SIC",
  },
  {
    label: "EN-ICE-SW-INFRA",
    value: "EN-ICE-SW-INFRA",
  },
  {
    label: "EN-MEF",
    value: "EN-MEF",
  },
  {
    label: "EN-MEF-SU-MTI JIRA users",
    value: "EN-MEF-SU-MTI JIRA users",
  },
  {
    label: "EN-MME CAD Exchange",
    value: "EN-MME CAD Exchange",
  },
  {
    label: "EN-MME Software",
    value: "EN-MME Software",
  },
  {
    label: "EN-MME-LOGISTIQUE",
    value: "EN-MME-LOGISTIQUE",
  },
  {
    label: "en-mme-ma-cam",
    value: "en-mme-ma-cam",
  },
  {
    label: "EN-MME-MM-NDT mailing list",
    value: "EN-MME-MM-NDT mailing list",
  },
  {
    label: "EN-SMM",
    value: "EN-SMM",
  },
  {
    label: "EN-STI",
    value: "EN-STI",
  },
  {
    label: "EN-STI collimator production",
    value: "EN-STI collimator production",
  },
  {
    label: "EN-STI-ECE",
    value: "EN-STI-ECE",
  },
  {
    label: "EN-STI-ECE-COLLIMATORS",
    value: "EN-STI-ECE-COLLIMATORS",
  },
  {
    label: "EN-STI-RBS ISOLDE Yield-Database",
    value: "EN-STI-RBS ISOLDE Yield-Database",
  },
  {
    label: "EN-STI-TCD Section",
    value: "EN-STI-TCD Section",
  },
  {
    label: "EN.MME",
    value: "EN.MME",
  },
  {
    label: "End of function notification",
    value: "End of function notification",
  },
  {
    label: "EndoTOFPET-US",
    value: "EndoTOFPET-US",
  },
  {
    label: "Energy",
    value: "Energy",
  },
  {
    label: "Energy Extraction Systems of LHC (Operation)",
    value: "Energy Extraction Systems of LHC (Operation)",
  },
  {
    label: "engineering  group",
    value: "engineering  group",
  },
  {
    label: "Engineering Software",
    value: "Engineering Software",
  },
  {
    label: "English Training",
    value: "English Training",
  },
  {
    label: "ENTERVISION",
    value: "ENTERVISION",
  },
  {
    label: "Entrepreneur",
    value: "Entrepreneur",
  },
  {
    label: "Enubet",
    value: "Enubet",
  },
  {
    label: "Environment Radioactive Source Test",
    value: "Environment Radioactive Source Test",
  },
  {
    label: "Environmental Monitoring",
    value: "Environmental Monitoring",
  },
  {
    label: "Environmental Prevention",
    value: "Environmental Prevention",
  },
  {
    label: "ENVISION",
    value: "ENVISION",
  },
  {
    label: "EOS and CERNBox Services",
    value: "EOS and CERNBox Services",
  },
  {
    label: "EOS be.h",
    value: "EOS be.h",
  },
  {
    label: "EOS Community",
    value: "EOS Community",
  },
  {
    label: "EOS Service",
    value: "EOS Service",
  },
  {
    label: "EOS-CMS",
    value: "EOS-CMS",
  },
  {
    label: "EOSCTA Service",
    value: "EOSCTA Service",
  },
  {
    label: "EP administration",
    value: "EP administration",
  },
  {
    label: "EP EXSO",
    value: "EP EXSO",
  },
  {
    label: "EP Graduate Programme Departmental Representatives",
    value: "EP Graduate Programme Departmental Representatives",
  },
  {
    label: "EP Graduate Programme Ex Officio",
    value: "EP Graduate Programme Ex Officio",
  },
  {
    label: "EP Graduate Programme Hiring Managers",
    value: "EP Graduate Programme Hiring Managers",
  },
  {
    label: "EP Graduate Programme Rankers",
    value: "EP Graduate Programme Rankers",
  },
  {
    label: "EP Graduates and Students",
    value: "EP Graduates and Students",
  },
  {
    label: "EP RD",
    value: "EP RD",
  },
  {
    label: "EP SO",
    value: "EP SO",
  },
  {
    label: "EP-AGS",
    value: "EP-AGS",
  },
  {
    label: "EP-AGS-egroup-Admin",
    value: "EP-AGS-egroup-Admin",
  },
  {
    label: "EP-CMG",
    value: "EP-CMG",
  },
  {
    label: "EP-ESE",
    value: "EP-ESE",
  },
  {
    label: "EP-ESE-BE Boards and Systems Team",
    value: "EP-ESE-BE Boards and Systems Team",
  },
  {
    label: "EP-ESE-ME-CHIPS",
    value: "EP-ESE-ME-CHIPS",
  },
  {
    label: "EP-RD WP Leaders",
    value: "EP-RD WP Leaders",
  },
  {
    label: "EP-RDET-WG3-Cal-Noble-Liquid",
    value: "EP-RDET-WG3-Cal-Noble-Liquid",
  },
  {
    label: "EP-Seminars and Colloquia",
    value: "EP-Seminars and Colloquia",
  },
  {
    label: "EP-SFT",
    value: "EP-SFT",
  },
  {
    label: "EP-UAD",
    value: "EP-UAD",
  },
  {
    label: "EPFL Machine Learning Activities",
    value: "EPFL Machine Learning Activities",
  },
  {
    label: "EPS",
    value: "EPS",
  },
  {
    label: "EPS-PED",
    value: "EPS-PED",
  },
  {
    label: "Equipment Code Management",
    value: "Equipment Code Management",
  },
  {
    label: "ERDIT",
    value: "ERDIT",
  },
  {
    label: "ERL17",
    value: "ERL17",
  },
  {
    label: "ERT",
    value: "ERT",
  },
  {
    label: "ESE",
    value: "ESE",
  },
  {
    label: "ESIPAP",
    value: "ESIPAP",
  },
  {
    label: "ESUPP community input on sustainability",
    value: "ESUPP community input on sustainability",
  },
  {
    label: "ETICS Project",
    value: "ETICS Project",
  },
  {
    label: "EuCAPT",
    value: "EuCAPT",
  },
  {
    label: "EUCARD",
    value: "EUCARD",
  },
  {
    label: "EUCARD2",
    value: "EUCARD2",
  },
  {
    label: "EuCARD2 WP10 collaboration",
    value: "EuCARD2 WP10 collaboration",
  },
  {
    label: "EuCARD2 WP11 Collimation",
    value: "EuCARD2 WP11 Collimation",
  },
  {
    label: "EUCARD2 WP4",
    value: "EUCARD2 WP4",
  },
  {
    label: "EuCARD2 WP5 XBEAM",
    value: "EuCARD2 WP5 XBEAM",
  },
  {
    label: "EURO-LABS",
    value: "EURO-LABS",
  },
  {
    label: "Euronnac",
    value: "Euronnac",
  },
  {
    label: "European projects",
    value: "European projects",
  },
  {
    label: "European Strategy Update",
    value: "European Strategy Update",
  },
  {
    label: "European-neutrino-groups",
    value: "European-neutrino-groups",
  },
  {
    label: "Evolutionary Algorithms for ROOT",
    value: "Evolutionary Algorithms for ROOT",
  },
  {
    label: "EXAS coordination",
    value: "EXAS coordination",
  },
  {
    label: "Exhibition",
    value: "Exhibition",
  },
  {
    label: "Experimental Areas",
    value: "Experimental Areas",
  },
  {
    label: "External Liaison Committee",
    value: "External Liaison Committee",
  },
  {
    label: "Facilities Management",
    value: "Facilities Management",
  },
  {
    label: "Fact Finding Procedures",
    value: "Fact Finding Procedures",
  },
  {
    label: "FAIR",
    value: "FAIR",
  },
  {
    label: "FAIR magnets tests at CERN",
    value: "FAIR magnets tests at CERN",
  },
  {
    label: "fake background in top analysis",
    value: "fake background in top analysis",
  },
  {
    label: "FAP Department",
    value: "FAP Department",
  },
  {
    label: "farewell drink",
    value: "farewell drink",
  },
  {
    label: "FASER experiment",
    value: "FASER experiment",
  },
  {
    label: "FASER Experiment Collaboration Board",
    value: "FASER Experiment Collaboration Board",
  },
  {
    label: "FASER experiment Executive Board",
    value: "FASER experiment Executive Board",
  },
  {
    label: "FASER Experiment Physics Analysis",
    value: "FASER Experiment Physics Analysis",
  },
  {
    label: "FASER Experiment Physics Coordination",
    value: "FASER Experiment Physics Coordination",
  },
  {
    label: "FASER experiment run managers",
    value: "FASER experiment run managers",
  },
  {
    label: "FASER experiment study group",
    value: "FASER experiment study group",
  },
  {
    label: "Fast PDF interpolation grid distribution and discussion",
    value: "Fast PDF interpolation grid distribution and discussion",
  },
  {
    label: "FastIC",
    value: "FastIC",
  },
  {
    label: "FastICpix CDN",
    value: "FastICpix CDN",
  },
  {
    label: "FCAL collaboration",
    value: "FCAL collaboration",
  },
  {
    label: "FCC",
    value: "FCC",
  },
  {
    label: "FCC Environmental report",
    value: "FCC Environmental report",
  },
  {
    label: "FCC Global Collaboration",
    value: "FCC Global Collaboration",
  },
  {
    label: "FCC- Istanbul Calisma Grubu",
    value: "FCC- Istanbul Calisma Grubu",
  },
  {
    label: "FCC-SSI1",
    value: "FCC-SSI1",
  },
  {
    label: "FCC-TR-GROUP",
    value: "FCC-TR-GROUP",
  },
  {
    label: "FCCCERN",
    value: "FCCCERN",
  },
  {
    label: "FCCIS",
    value: "FCCIS",
  },
  {
    label: "FE Software Team",
    value: "FE Software Team",
  },
  {
    label: "FECHW",
    value: "FECHW",
  },
  {
    label: "fecos",
    value: "fecos",
  },
  {
    label: "Fellows member of the PH-ADE group",
    value: "Fellows member of the PH-ADE group",
  },
  {
    label: "Fence",
    value: "Fence",
  },
  {
    label: "Fibre Optics",
    value: "Fibre Optics",
  },
  {
    label: "fire brigade",
    value: "fire brigade",
  },
  {
    label: "Fire Safety Rules",
    value: "Fire Safety Rules",
  },
  {
    label: "FIRIA case study",
    value: "FIRIA case study",
  },
  {
    label: "Flavour Physics",
    value: "Flavour Physics",
  },
  {
    label: "Flourocarbon investigations",
    value: "Flourocarbon investigations",
  },
  {
    label: "fluidic-data",
    value: "fluidic-data",
  },
  {
    label: "FLUKA",
    value: "FLUKA",
  },
  {
    label: "FLUKA.CERN",
    value: "FLUKA.CERN",
  },
  {
    label: "Flying spaghetti monster",
    value: "Flying spaghetti monster",
  },
  {
    label: "football",
    value: "football",
  },
  {
    label: "formal-methods",
    value: "formal-methods",
  },
  {
    label: "forum about Muon electronics",
    value: "forum about Muon electronics",
  },
  {
    label: "Forum of AIDAInnova French groups",
    value: "Forum of AIDAInnova French groups",
  },
  {
    label: "Forum on Tracking Detector Mechanics attendants",
    value: "Forum on Tracking Detector Mechanics attendants",
  },
  {
    label: "Forum on Tracking Detector Mechanics organisers",
    value: "Forum on Tracking Detector Mechanics organisers",
  },
  {
    label: "Forwarding email Egroup",
    value: "Forwarding email Egroup",
  },
  {
    label: "Forwarding for Judita Mamuzic",
    value: "Forwarding for Judita Mamuzic",
  },
  {
    label: "Fourocarbon Mixture Studies",
    value: "Fourocarbon Mixture Studies",
  },
  {
    label: "FP",
    value: "FP",
  },
  {
    label: "FP BO",
    value: "FP BO",
  },
  {
    label: "FP ICS",
    value: "FP ICS",
  },
  {
    label: "FP Procedures",
    value: "FP Procedures",
  },
  {
    label: "FP Role Automatic",
    value: "FP Role Automatic",
  },
  {
    label: "FP web",
    value: "FP web",
  },
  {
    label: "FPF",
    value: "FPF",
  },
  {
    label: "FPPG",
    value: "FPPG",
  },
  {
    label: "FPS FSU technical team",
    value: "FPS FSU technical team",
  },
  {
    label: "FRC  Financial Review Committee",
    value: "FRC  Financial Review Committee",
  },
  {
    label: "Free running DAQ",
    value: "Free running DAQ",
  },
  {
    label: "French Courses Mailing List",
    value: "French Courses Mailing List",
  },
  {
    label: "Frontier distributed database caching",
    value: "Frontier distributed database caching",
  },
  {
    label: "FSI machines devops",
    value: "FSI machines devops",
  },
  {
    label: "FSI Systems in GM Group",
    value: "FSI Systems in GM Group",
  },
  {
    label: "FSP-2024",
    value: "FSP-2024",
  },
  {
    label: "FSU",
    value: "FSU",
  },
  {
    label: "FSU2",
    value: "FSU2",
  },
  {
    label: "FTEC",
    value: "FTEC",
  },
  {
    label: "FTEC Spanish Trainees",
    value: "FTEC Spanish Trainees",
  },
  {
    label: "Full Remote Alignment System",
    value: "Full Remote Alignment System",
  },
  {
    label: "Fun",
    value: "Fun",
  },
  {
    label: "functional-safety",
    value: "functional-safety",
  },
  {
    label: "Fusion Technology Coordination unit",
    value: "Fusion Technology Coordination unit",
  },
  {
    label: "futbol team list",
    value: "futbol team list",
  },
  {
    label: "Futsal",
    value: "Futsal",
  },
  {
    label: "Future Acceleration Techniques",
    value: "Future Acceleration Techniques",
  },
  {
    label: "Future Colliders",
    value: "Future Colliders",
  },
  {
    label: "Future Colliders Unit",
    value: "Future Colliders Unit",
  },
  {
    label: "fwAccessControl configuration",
    value: "fwAccessControl configuration",
  },
  {
    label: "fwAccessControl domain",
    value: "fwAccessControl domain",
  },
  {
    label: "fwAccessControl privilege",
    value: "fwAccessControl privilege",
  },
  {
    label: "fwAccessControl role",
    value: "fwAccessControl role",
  },
  {
    label: "G4SEE",
    value: "G4SEE",
  },
  {
    label: "GAMBIT",
    value: "GAMBIT",
  },
  {
    label: "game",
    value: "game",
  },
  {
    label: "Ganga",
    value: "Ganga",
  },
  {
    label: "gas",
    value: "gas",
  },
  {
    label: "Gas detection",
    value: "Gas detection",
  },
  {
    label: "GBAR list for activity in the experimental area",
    value: "GBAR list for activity in the experimental area",
  },
  {
    label: "GBAR users group",
    value: "GBAR users group",
  },
  {
    label: "Gbar-list",
    value: "Gbar-list",
  },
  {
    label: "GBT",
    value: "GBT",
  },
  {
    label: "GDD",
    value: "GDD",
  },
  {
    label: "GDML",
    value: "GDML",
  },
  {
    label: "Geant4",
    value: "Geant4",
  },
  {
    label: "Geant4 Training",
    value: "Geant4 Training",
  },
  {
    label: "Geant4-early-career-researcher",
    value: "Geant4-early-career-researcher",
  },
  {
    label: "Gender in science",
    value: "Gender in science",
  },
  {
    label: "German WLCG Contribution",
    value: "German WLCG Contribution",
  },
  {
    label: "german-dac",
    value: "german-dac",
  },
  {
    label: "GESMAR",
    value: "GESMAR",
  },
  {
    label: "GGUS support list",
    value: "GGUS support list",
  },
  {
    label: "GIF",
    value: "GIF",
  },
  {
    label: "GIF RPC coordination and analysis ",
    value: "GIF RPC coordination and analysis ",
  },
  {
    label: "gilles billard",
    value: "gilles billard",
  },
  {
    label: "GIS",
    value: "GIS",
  },
  {
    label: "GIS 2nd line support",
    value: "GIS 2nd line support",
  },
  {
    label: "GIS Administrators",
    value: "GIS Administrators",
  },
  {
    label: "GIS Extraction",
    value: "GIS Extraction",
  },
  {
    label: "GIS Hotel Booking",
    value: "GIS Hotel Booking",
  },
  {
    label: "GIS layers acces",
    value: "GIS layers acces",
  },
  {
    label: "gis-edition",
    value: "gis-edition",
  },
  {
    label: "Git",
    value: "Git",
  },
  {
    label: "Git counterpart of atlas-readaccess-svn",
    value: "Git counterpart of atlas-readaccess-svn",
  },
  {
    label: "GitLab Admin Group",
    value: "GitLab Admin Group",
  },
  {
    label: "Gitlab service users",
    value: "Gitlab service users",
  },
  {
    label: "GitLab test users",
    value: "GitLab test users",
  },
  {
    label: "Glance dev",
    value: "Glance dev",
  },
  {
    label: "Glance Egroups",
    value: "Glance Egroups",
  },
  {
    label: "GLIB project",
    value: "GLIB project",
  },
  {
    label: "Globe",
    value: "Globe",
  },
  {
    label: "GMAO",
    value: "GMAO",
  },
  {
    label: "goacinto",
    value: "goacinto",
  },
  {
    label: "Golf",
    value: "Golf",
  },
  {
    label: "google",
    value: "google",
  },
  {
    label: "GPU Users in CMS",
    value: "GPU Users in CMS",
  },
  {
    label: "Graphic Design Team",
    value: "Graphic Design Team",
  },
  {
    label: "Greece",
    value: "Greece",
  },
  {
    label: "Green Village",
    value: "Green Village",
  },
  {
    label: "Grid experts in ALICE",
    value: "Grid experts in ALICE",
  },
  {
    label: "GridPP",
    value: "GridPP",
  },
  {
    label: "GRIDPP PMB",
    value: "GRIDPP PMB",
  },
  {
    label: "group and mailing list",
    value: "group and mailing list",
  },
  {
    label: "Group meeting",
    value: "Group meeting",
  },
  {
    label: "Gruppo1 Bari",
    value: "Gruppo1 Bari",
  },
  {
    label: "GS C3 meeting members",
    value: "GS C3 meeting members",
  },
  {
    label: "GS-AIS-PM Security Filters",
    value: "GS-AIS-PM Security Filters",
  },
  {
    label: "GS-ASE-AC",
    value: "GS-ASE-AC",
  },
  {
    label: "GS-FB fire brigade pompiers",
    value: "GS-FB fire brigade pompiers",
  },
  {
    label: "GS-SE-FMW Section Admin",
    value: "GS-SE-FMW Section Admin",
  },
  {
    label: "GS-SE-HE",
    value: "GS-SE-HE",
  },
  {
    label: "GS-SEM-HE",
    value: "GS-SEM-HE",
  },
  {
    label: "HammerCloud",
    value: "HammerCloud",
  },
  {
    label: "Harassment Investigation Panel",
    value: "Harassment Investigation Panel",
  },
  {
    label: "Hard Probes 2024 conference announcement (no-reply)",
    value: "Hard Probes 2024 conference announcement (no-reply)",
  },
  {
    label: "Hard Probes 2024 Conference IAC",
    value: "Hard Probes 2024 Conference IAC",
  },
  {
    label: "Hard Probes 2024 Conference LOC",
    value: "Hard Probes 2024 Conference LOC",
  },
  {
    label: "Hard Probes 2024 Contact",
    value: "Hard Probes 2024 Contact",
  },
  {
    label: "Hard Probes 2024 LOC Core",
    value: "Hard Probes 2024 LOC Core",
  },
  {
    label: "Hard Probes 2024 LOC Japan",
    value: "Hard Probes 2024 LOC Japan",
  },
  {
    label: "Hard Probes 2024 Program Committee",
    value: "Hard Probes 2024 Program Committee",
  },
  {
    label: "Hard Probes 2024 Support",
    value: "Hard Probes 2024 Support",
  },
  {
    label: "Hard Probes 2024 Visa Application",
    value: "Hard Probes 2024 Visa Application",
  },
  {
    label: "Hardware Commissioning and operation Applications ",
    value: "Hardware Commissioning and operation Applications ",
  },
  {
    label: "Hbb analyses in ETH CMS group",
    value: "Hbb analyses in ETH CMS group",
  },
  {
    label: "HCAL",
    value: "HCAL",
  },
  {
    label: "HCPSS",
    value: "HCPSS",
  },
  {
    label: "Heavy ion data quality",
    value: "Heavy ion data quality",
  },
  {
    label: "Heavy Ion Jet Physics",
    value: "Heavy Ion Jet Physics",
  },
  {
    label: "Heavy Ion Physics",
    value: "Heavy Ion Physics",
  },
  {
    label: "HEPHY Joplin",
    value: "HEPHY Joplin",
  },
  {
    label: "HEPHY Vienna",
    value: "HEPHY Vienna",
  },
  {
    label: "HEPTech Symposium",
    value: "HEPTech Symposium",
  },
  {
    label: "Heritage objects",
    value: "Heritage objects",
  },
  {
    label: "hfm",
    value: "hfm",
  },
  {
    label: "HGCAL BE",
    value: "HGCAL BE",
  },
  {
    label: "HGCAL DPG",
    value: "HGCAL DPG",
  },
  {
    label: "HH Event Generation",
    value: "HH Event Generation",
  },
  {
    label: "HI-ECN3-PROJECT",
    value: "HI-ECN3-PROJECT",
  },
  {
    label: "HI-LUMI",
    value: "HI-LUMI",
  },
  {
    label: "HIE-ISOLDE",
    value: "HIE-ISOLDE",
  },
  {
    label: "Higgs",
    value: "Higgs",
  },
  {
    label: "Higgs Combination",
    value: "Higgs Combination",
  },
  {
    label: "Higgs Conference",
    value: "Higgs Conference",
  },
  {
    label: "Higgs to Gamma Gamma group at Saha Inst. of Nuclear Physics",
    value: "Higgs to Gamma Gamma group at Saha Inst. of Nuclear Physics",
  },
  {
    label: "High Intensity ECN3 Upgrade Study Project",
    value: "High Intensity ECN3 Upgrade Study Project",
  },
  {
    label: "High Intensity Kaon Experiments (HIKE)",
    value: "High Intensity Kaon Experiments (HIKE)",
  },
  {
    label: "High Performance Computing Applications for HEP",
    value: "High Performance Computing Applications for HEP",
  },
  {
    label: "High Power Converters Section Members",
    value: "High Power Converters Section Members",
  },
  {
    label: "High Precision Timing for Experiments",
    value: "High Precision Timing for Experiments",
  },
  {
    label: "Hightec",
    value: "Hightec",
  },
  {
    label: "HIPPO",
    value: "HIPPO",
  },
  {
    label: "HIPTEK communications",
    value: "HIPTEK communications",
  },
  {
    label: "HiRadMat Facility",
    value: "HiRadMat Facility",
  },
  {
    label: "HITRI",
    value: "HITRI",
  },
  {
    label: "HITRIplus",
    value: "HITRIplus",
  },
  {
    label: "HL-LHC",
    value: "HL-LHC",
  },
  {
    label: "HL-LHC Beam Screen",
    value: "HL-LHC Beam Screen",
  },
  {
    label: "HL-LHC Facility Coordinators",
    value: "HL-LHC Facility Coordinators",
  },
  {
    label: "HL-LHC Safety Approvers",
    value: "HL-LHC Safety Approvers",
  },
  {
    label: "HL-ZDC",
    value: "HL-ZDC",
  },
  {
    label: "Hog (HDL on git)",
    value: "Hog (HDL on git)",
  },
  {
    label: "honkanen",
    value: "honkanen",
  },
  {
    label: "Honorary members",
    value: "Honorary members",
  },
  {
    label: "Hostel",
    value: "Hostel",
  },
  {
    label: "Hostlab",
    value: "Hostlab",
  },
  {
    label: "Hot Quarks Workshop",
    value: "Hot Quarks Workshop",
  },
  {
    label: "HPA CAD PC  users",
    value: "HPA CAD PC  users",
  },
  {
    label: "HPA CAD TEST PC  users",
    value: "HPA CAD TEST PC  users",
  },
  {
    label: "HPA section members",
    value: "HPA section members",
  },
  {
    label: "HPA Supervisors",
    value: "HPA Supervisors",
  },
  {
    label: "HPTW2026",
    value: "HPTW2026",
  },
  {
    label: "HR",
    value: "HR",
  },
  {
    label: "HR circulars and Staff Rules and Regulations",
    value: "HR circulars and Staff Rules and Regulations",
  },
  {
    label: "HR department",
    value: "HR department",
  },
  {
    label: "HR Records Office",
    value: "HR Records Office",
  },
  {
    label: "HR Services",
    value: "HR Services",
  },
  {
    label: "HR-CB-B",
    value: "HR-CB-B",
  },
  {
    label: "HR-CB-C",
    value: "HR-CB-C",
  },
  {
    label: "HR-LD",
    value: "HR-LD",
  },
  {
    label: "HR-SPS",
    value: "HR-SPS",
  },
  {
    label: "HR-TA",
    value: "HR-TA",
  },
  {
    label: "HSE",
    value: "HSE",
  },
  {
    label: "HSE ",
    value: "HSE ",
  },
  {
    label: "HSE LIMS",
    value: "HSE LIMS",
  },
  {
    label: "HSE Snow support lines",
    value: "HSE Snow support lines",
  },
  {
    label: "HSE TMB",
    value: "HSE TMB",
  },
  {
    label: "HSF",
    value: "HSF",
  },
  {
    label: "HSL Linac4 source best effort",
    value: "HSL Linac4 source best effort",
  },
  {
    label: "HSSIP",
    value: "HSSIP",
  },
  {
    label: "Hyper-K INFN Reps",
    value: "Hyper-K INFN Reps",
  },
  {
    label: "HZZ git list",
    value: "HZZ git list",
  },
  {
    label: "HZZ temporary list",
    value: "HZZ temporary list",
  },
  {
    label: "IAXO",
    value: "IAXO",
  },
  {
    label: "IAXO physics",
    value: "IAXO physics",
  },
  {
    label: "IBDRS",
    value: "IBDRS",
  },
  {
    label: "ICALEPCS",
    value: "ICALEPCS",
  },
  {
    label: "Icarus",
    value: "Icarus",
  },
  {
    label: "ICHEP2020",
    value: "ICHEP2020",
  },
  {
    label: "ICHEP2024",
    value: "ICHEP2024",
  },
  {
    label: "ICS Industrial Controls",
    value: "ICS Industrial Controls",
  },
  {
    label: "IdeaSquare (B3179)",
    value: "IdeaSquare (B3179)",
  },
  {
    label: "IdeaSquare administration ",
    value: "IdeaSquare administration ",
  },
  {
    label: "Identity Management",
    value: "Identity Management",
  },
  {
    label: "IEEE NPSS",
    value: "IEEE NPSS",
  },
  {
    label: "IEEE RealTime",
    value: "IEEE RealTime",
  },
  {
    label: "IEPLC",
    value: "IEPLC",
  },
  {
    label: "IFAST",
    value: "IFAST",
  },
  {
    label: "ihep people ams",
    value: "ihep people ams",
  },
  {
    label: "ILCDIRAC",
    value: "ILCDIRAC",
  },
  {
    label: "IMCC",
    value: "IMCC",
  },
  {
    label: "IMPACT",
    value: "IMPACT",
  },
  {
    label: "Impedance Working Group",
    value: "Impedance Working Group",
  },
  {
    label: "Implementation of ECFA Detector RD Roadmap",
    value: "Implementation of ECFA Detector RD Roadmap",
  },
  {
    label: "IN2P3 people interested in AIDA",
    value: "IN2P3 people interested in AIDA",
  },
  {
    label: "INCT-CERN-Brasil",
    value: "INCT-CERN-Brasil",
  },
  {
    label: "India CMS Tracker Group",
    value: "India CMS Tracker Group",
  },
  {
    label: "india-hf",
    value: "india-hf",
  },
  {
    label: "Indian Members in ALICE",
    value: "Indian Members in ALICE",
  },
  {
    label: "Indians working at CERN",
    value: "Indians working at CERN",
  },
  {
    label: "Indico",
    value: "Indico",
  },
  {
    label: "Industrial Controls Technical Committee",
    value: "Industrial Controls Technical Committee",
  },
  {
    label: "INFIERI project",
    value: "INFIERI project",
  },
  {
    label: "info",
    value: "info",
  },
  {
    label: "Infor EAM",
    value: "Infor EAM",
  },
  {
    label: "Infor LN",
    value: "Infor LN",
  },
  {
    label: "Information about OP References Tool",
    value: "Information about OP References Tool",
  },
  {
    label: "INJECTEUR DECABLING",
    value: "INJECTEUR DECABLING",
  },
  {
    label: "Injector Machine Development",
    value: "Injector Machine Development",
  },
  {
    label: "Injector Optics",
    value: "Injector Optics",
  },
  {
    label: "Injector Restart Working Group",
    value: "Injector Restart Working Group",
  },
  {
    label: "Inner Detector",
    value: "Inner Detector",
  },
  {
    label: "Inner Detector Environmental Issues",
    value: "Inner Detector Environmental Issues",
  },
  {
    label: "Innovation",
    value: "Innovation",
  },
  {
    label: "Inspecteurs",
    value: "Inspecteurs",
  },
  {
    label: "Inspector",
    value: "Inspector",
  },
  {
    label: "inspire",
    value: "inspire",
  },
  {
    label: "Institutional",
    value: "Institutional",
  },
  {
    label: "Inter-Experiment Radiation Damage",
    value: "Inter-Experiment Radiation Damage",
  },
  {
    label: "Interlocks",
    value: "Interlocks",
  },
  {
    label: "Internal documents",
    value: "Internal documents",
  },
  {
    label: "International Relations",
    value: "International Relations",
  },
  {
    label: "International Union of Pure and Applied Physics",
    value: "International Union of Pure and Applied Physics",
  },
  {
    label: "Ions",
    value: "Ions",
  },
  {
    label: "iOS Support",
    value: "iOS Support",
  },
  {
    label: "IP nodos de la Red Tematica",
    value: "IP nodos de la Red Tematica",
  },
  {
    label: "IPAC Coordination Committee",
    value: "IPAC Coordination Committee",
  },
  {
    label: "IPB management",
    value: "IPB management",
  },
  {
    label: "IPBus",
    value: "IPBus",
  },
  {
    label: "iPPOG",
    value: "iPPOG",
  },
  {
    label: "IPSAS17 - Property plant  Equipment",
    value: "IPSAS17 - Property plant  Equipment",
  },
  {
    label: "IPT Department",
    value: "IPT Department",
  },
  {
    label: "IPv6",
    value: "IPv6",
  },
  {
    label: "IR admin",
    value: "IR admin",
  },
  {
    label: "IR Sector",
    value: "IR Sector",
  },
  {
    label: "IR-ECO-EN Section",
    value: "IR-ECO-EN Section",
  },
  {
    label: "IR-ECO-TSP",
    value: "IR-ECO-TSP",
  },
  {
    label: "IR-ECO-VI section",
    value: "IR-ECO-VI section",
  },
  {
    label: "ir-sg-complete",
    value: "ir-sg-complete",
  },
  {
    label: "IR3-experiment",
    value: "IR3-experiment",
  },
  {
    label: "IRRAD artificial intelligence studies",
    value: "IRRAD artificial intelligence studies",
  },
  {
    label: "Irradiation",
    value: "Irradiation",
  },
  {
    label: "iSAS WorkPackage 1",
    value: "iSAS WorkPackage 1",
  },
  {
    label: "ISMD",
    value: "ISMD",
  },
  {
    label: "ISOLDE",
    value: "ISOLDE",
  },
  {
    label: "Isolde Decay Station",
    value: "Isolde Decay Station",
  },
  {
    label: "ISOLDE DFT",
    value: "ISOLDE DFT",
  },
  {
    label: "ISOLDE experiment",
    value: "ISOLDE experiment",
  },
  {
    label: "ISOLDE IBDRS",
    value: "ISOLDE IBDRS",
  },
  {
    label: "ISOLDE MEDICIS apps",
    value: "ISOLDE MEDICIS apps",
  },
  {
    label: "ISOLDE Robot",
    value: "ISOLDE Robot",
  },
  {
    label: "ISOLDE Safety",
    value: "ISOLDE Safety",
  },
  {
    label: "ISOLDE Software",
    value: "ISOLDE Software",
  },
  {
    label: "ISOLDE Solenoidal Spectrometer",
    value: "ISOLDE Solenoidal Spectrometer",
  },
  {
    label: "ISOTDAQ Schools",
    value: "ISOTDAQ Schools",
  },
  {
    label: "IT",
    value: "IT",
  },
  {
    label: "IT analytics working group",
    value: "IT analytics working group",
  },
  {
    label: "it car pool",
    value: "it car pool",
  },
  {
    label: "IT Community Support",
    value: "IT Community Support",
  },
  {
    label: "IT Database Storage",
    value: "IT Database Storage",
  },
  {
    label: "IT Engineering Applications",
    value: "IT Engineering Applications",
  },
  {
    label: "IT Experiment Support",
    value: "IT Experiment Support",
  },
  {
    label: "IT FAS",
    value: "IT FAS",
  },
  {
    label: "IT Hadoop",
    value: "IT Hadoop",
  },
  {
    label: "IT HIRING",
    value: "IT HIRING",
  },
  {
    label: "IT Innovation",
    value: "IT Innovation",
  },
  {
    label: "IT koji.cern.ch egroups",
    value: "IT koji.cern.ch egroups",
  },
  {
    label: "IT Monitoring",
    value: "IT Monitoring",
  },
  {
    label: "IT Review",
    value: "IT Review",
  },
  {
    label: "IT software distribution",
    value: "IT software distribution",
  },
  {
    label: "IT SPACE",
    value: "IT SPACE",
  },
  {
    label: "IT Storage CERN Tape Archive",
    value: "IT Storage CERN Tape Archive",
  },
  {
    label: "IT Version Control",
    value: "IT Version Control",
  },
  {
    label: "IT Websites",
    value: "IT Websites",
  },
  {
    label: "IT-CS Network Engineering",
    value: "IT-CS Network Engineering",
  },
  {
    label: "IT-CS Telecom Engineering",
    value: "IT-CS Telecom Engineering",
  },
  {
    label: "IT-DB Infrastructure",
    value: "IT-DB Infrastructure",
  },
  {
    label: "it-dpo-team",
    value: "it-dpo-team",
  },
  {
    label: "IT-FAS",
    value: "IT-FAS",
  },
  {
    label: "IT-FTI",
    value: "IT-FTI",
  },
  {
    label: "IT-PMO-SharePoint",
    value: "IT-PMO-SharePoint",
  },
  {
    label: "IT-Services",
    value: "IT-Services",
  },
  {
    label: "IT-Storage",
    value: "IT-Storage",
  },
  {
    label: "IT-STORAGE-CASTOR",
    value: "IT-STORAGE-CASTOR",
  },
  {
    label: "IT-Support S182",
    value: "IT-Support S182",
  },
  {
    label: "ITCS database users",
    value: "ITCS database users",
  },
  {
    label: "ITDCIM",
    value: "ITDCIM",
  },
  {
    label: "ITIL service management",
    value: "ITIL service management",
  },
  {
    label: "ITk",
    value: "ITk",
  },
  {
    label: "ITK-Services",
    value: "ITK-Services",
  },
  {
    label: "ITS-IB stave assembly",
    value: "ITS-IB stave assembly",
  },
  {
    label: "iupap",
    value: "iupap",
  },
  {
    label: "IWHSS-QCDN-2025",
    value: "IWHSS-QCDN-2025",
  },
  {
    label: "Japan MM Activities",
    value: "Japan MM Activities",
  },
  {
    label: "Jardin denfants de lAP",
    value: "Jardin denfants de lAP",
  },
  {
    label: "Jardin des Particules",
    value: "Jardin des Particules",
  },
  {
    label: "Java development",
    value: "Java development",
  },
  {
    label: "JCOP",
    value: "JCOP",
  },
  {
    label: "jeedy",
    value: "jeedy",
  },
  {
    label: "Jira access rigths",
    value: "Jira access rigths",
  },
  {
    label: "JMS Access Rights",
    value: "JMS Access Rights",
  },
  {
    label: "JMT access rights",
    value: "JMT access rights",
  },
  {
    label: "JUNO",
    value: "JUNO",
  },
  {
    label: "key4hep - software",
    value: "key4hep - software",
  },
  {
    label: "KITRY interventions",
    value: "KITRY interventions",
  },
  {
    label: "KLever",
    value: "KLever",
  },
  {
    label: "KM3Net members",
    value: "KM3Net members",
  },
  {
    label: "KNU Moon Lab",
    value: "KNU Moon Lab",
  },
  {
    label: "KNU Moon Lab for Grad",
    value: "KNU Moon Lab for Grad",
  },
  {
    label: "koALICE",
    value: "koALICE",
  },
  {
    label: "Korea-FC-Consortium",
    value: "Korea-FC-Consortium",
  },
  {
    label: "KR LHC exp-pheno",
    value: "KR LHC exp-pheno",
  },
  {
    label: "Kryolize",
    value: "Kryolize",
  },
  {
    label: "kubernetes",
    value: "kubernetes",
  },
  {
    label: "KUCMS Rogan Grad Students",
    value: "KUCMS Rogan Grad Students",
  },
  {
    label: "kuranos",
    value: "kuranos",
  },
  {
    label: "Laboratory Management",
    value: "Laboratory Management",
  },
  {
    label: "LabviewWorkshop",
    value: "LabviewWorkshop",
  },
  {
    label: "LAGUNA-LBNO",
    value: "LAGUNA-LBNO",
  },
  {
    label: "LanDB Portal",
    value: "LanDB Portal",
  },
  {
    label: "LASER (Alarms) Data Management",
    value: "LASER (Alarms) Data Management",
  },
  {
    label: "Laser Treatment Lab Users",
    value: "Laser Treatment Lab Users",
  },
  {
    label: "Layout",
    value: "Layout",
  },
  {
    label: "Layout-rbac",
    value: "Layout-rbac",
  },
  {
    label: "LCD projectgroup",
    value: "LCD projectgroup",
  },
  {
    label: "LCVision-Detectors",
    value: "LCVision-Detectors",
  },
  {
    label: "LDG",
    value: "LDG",
  },
  {
    label: "LDMX",
    value: "LDMX",
  },
  {
    label: "LEP data conversation",
    value: "LEP data conversation",
  },
  {
    label: "LHC beam operation",
    value: "LHC beam operation",
  },
  {
    label: "LHC beam physics",
    value: "LHC beam physics",
  },
  {
    label: "LHC Collimation",
    value: "LHC Collimation",
  },
  {
    label: "LHC collimator test benches",
    value: "LHC collimator test benches",
  },
  {
    label: "LHC cooling",
    value: "LHC cooling",
  },
  {
    label: "LHC Early Career",
    value: "LHC Early Career",
  },
  {
    label: "LHC Early Career Mentorship Scheme",
    value: "LHC Early Career Mentorship Scheme",
  },
  {
    label: "LHC early career scientist fora",
    value: "LHC early career scientist fora",
  },
  {
    label: "LHC Energy Extraction Systems",
    value: "LHC Energy Extraction Systems",
  },
  {
    label: "LHC Forward Physics Experiments",
    value: "LHC Forward Physics Experiments",
  },
  {
    label: "LHC H WG Conveners",
    value: "LHC H WG Conveners",
  },
  {
    label: "LHC Higgs Combination Group",
    value: "LHC Higgs Combination Group",
  },
  {
    label: "LHC Higgs Cross Section Working Group",
    value: "LHC Higgs Cross Section Working Group",
  },
  {
    label: "LHC Luminosity Calibration and Monitoring",
    value: "LHC Luminosity Calibration and Monitoring",
  },
  {
    label: "LHC Machine Developments",
    value: "LHC Machine Developments",
  },
  {
    label: "lhc operation physicistsenginners",
    value: "lhc operation physicistsenginners",
  },
  {
    label: "LHC operations",
    value: "LHC operations",
  },
  {
    label: "LHC performance",
    value: "LHC performance",
  },
  {
    label: "LHC physics centre",
    value: "LHC physics centre",
  },
  {
    label: "LHC physics groups",
    value: "LHC physics groups",
  },
  {
    label: "LHC Post Mortem",
    value: "LHC Post Mortem",
  },
  {
    label: "LHC Programme Coordination",
    value: "LHC Programme Coordination",
  },
  {
    label: "LHC Reinterpretation",
    value: "LHC Reinterpretation",
  },
  {
    label: "LHC VOs monitoring",
    value: "LHC VOs monitoring",
  },
  {
    label: "LHC-Hardware-Commissionning",
    value: "LHC-Hardware-Commissionning",
  },
  {
    label: "LHC-LS1",
    value: "LHC-LS1",
  },
  {
    label: "LHC-Luminosirity",
    value: "LHC-Luminosirity",
  },
  {
    label: "LHC-Luminosity",
    value: "LHC-Luminosity",
  },
  {
    label: "LHC-Luminosity beam-beam emittance",
    value: "LHC-Luminosity beam-beam emittance",
  },
  {
    label: "LHC-R2E",
    value: "LHC-R2E",
  },
  {
    label: "LHC-RRB",
    value: "LHC-RRB",
  },
  {
    label: "LHCathome",
    value: "LHCathome",
  },
  {
    label: "LHCb",
    value: "LHCb",
  },
  {
    label: "LHCb  CAD  Integration Office",
    value: "LHCb  CAD  Integration Office",
  },
  {
    label: "LHCb -CAD  Integration Office",
    value: "LHCb -CAD  Integration Office",
  },
  {
    label: "LHCb calorimeter",
    value: "LHCb calorimeter",
  },
  {
    label: "LHCb Computing",
    value: "LHCb Computing",
  },
  {
    label: "LHCb Computing Operations",
    value: "LHCb Computing Operations",
  },
  {
    label: "LHCb Data DPA",
    value: "LHCb Data DPA",
  },
  {
    label: "LHCb early measurements with 2021 data task force",
    value: "LHCb early measurements with 2021 data task force",
  },
  {
    label: "LHCb Fence",
    value: "LHCb Fence",
  },
  {
    label: "LHCb FSC",
    value: "LHCb FSC",
  },
  {
    label: "LHCb General Discussions",
    value: "LHCb General Discussions",
  },
  {
    label: "LHCb HyperNews",
    value: "LHCb HyperNews",
  },
  {
    label: "LHCb luminosity",
    value: "LHCb luminosity",
  },
  {
    label: "LHCb Mighty",
    value: "LHCb Mighty",
  },
  {
    label: "LHCb ML Forum",
    value: "LHCb ML Forum",
  },
  {
    label: "LHCb MUON",
    value: "LHCb MUON",
  },
  {
    label: "LHCb Muon Upgrade",
    value: "LHCb Muon Upgrade",
  },
  {
    label: "LHCb Notifications",
    value: "LHCb Notifications",
  },
  {
    label: "LHCb Online",
    value: "LHCb Online",
  },
  {
    label: "LHCb online data monitoring",
    value: "LHCb online data monitoring",
  },
  {
    label: "LHCb Operations",
    value: "LHCb Operations",
  },
  {
    label: "LHCb Outreach",
    value: "LHCb Outreach",
  },
  {
    label: "LHCb Physics",
    value: "LHCb Physics",
  },
  {
    label: "LHCb PLUME testbeam",
    value: "LHCb PLUME testbeam",
  },
  {
    label: "LHCb publication observers",
    value: "LHCb publication observers",
  },
  {
    label: "LHCb RICH",
    value: "LHCb RICH",
  },
  {
    label: "LHCb RICH mirror alignment",
    value: "LHCb RICH mirror alignment",
  },
  {
    label: "LHCb RICH upgrade",
    value: "LHCb RICH upgrade",
  },
  {
    label: "LHCb RICH Upgrade Working Group for the Elementary Cell",
    value: "LHCb RICH Upgrade Working Group for the Elementary Cell",
  },
  {
    label: "LHCb SciFi",
    value: "LHCb SciFi",
  },
  {
    label: "LHCb SMOG operations",
    value: "LHCb SMOG operations",
  },
  {
    label: "LHCb Subversion",
    value: "LHCb Subversion",
  },
  {
    label: "LHCb technical coordination",
    value: "LHCb technical coordination",
  },
  {
    label: "LHCb Tracking and Alignment",
    value: "LHCb Tracking and Alignment",
  },
  {
    label: "LHCb Trigger",
    value: "LHCb Trigger",
  },
  {
    label: "LHCb Upgrade",
    value: "LHCb Upgrade",
  },
  {
    label: "LHCb Upgrade II",
    value: "LHCb Upgrade II",
  },
  {
    label: "LHCb Upgrade readout board",
    value: "LHCb Upgrade readout board",
  },
  {
    label: "LHCb UT upgrade Shifts",
    value: "LHCb UT upgrade Shifts",
  },
  {
    label: "LHCb VELO Operations",
    value: "LHCb VELO Operations",
  },
  {
    label: "LHCb VELO upgrade",
    value: "LHCb VELO upgrade",
  },
  {
    label: "LHCb VELO Upgrade II",
    value: "LHCb VELO Upgrade II",
  },
  {
    label: "LHCb web",
    value: "LHCb web",
  },
  {
    label: "LHCb-ECAL-design",
    value: "LHCb-ECAL-design",
  },
  {
    label: "LHCB-Ecal-LS3-Design",
    value: "LHCB-Ecal-LS3-Design",
  },
  {
    label: "lhcb-general",
    value: "lhcb-general",
  },
  {
    label: "lhcb-ucas group",
    value: "lhcb-ucas group",
  },
  {
    label: "LHCbMagnet",
    value: "LHCbMagnet",
  },
  {
    label: "LHCf",
    value: "LHCf",
  },
  {
    label: "LHCHome",
    value: "LHCHome",
  },
  {
    label: "LHCHome Boinc webmasters",
    value: "LHCHome Boinc webmasters",
  },
  {
    label: "LHCHWG WG4 Di-Higgs wokrshop ",
    value: "LHCHWG WG4 Di-Higgs wokrshop ",
  },
  {
    label: "LHCONE",
    value: "LHCONE",
  },
  {
    label: "LHCOPN",
    value: "LHCOPN",
  },
  {
    label: "LHCOPN Operations",
    value: "LHCOPN Operations",
  },
  {
    label: "LHCP2021",
    value: "LHCP2021",
  },
  {
    label: "LHCP2022",
    value: "LHCP2022",
  },
  {
    label: "LHCP2023",
    value: "LHCP2023",
  },
  {
    label: "LHCP2026",
    value: "LHCP2026",
  },
  {
    label: "LHe for cryogenics",
    value: "LHe for cryogenics",
  },
  {
    label: "LHeC",
    value: "LHeC",
  },
  {
    label: "Liber",
    value: "Liber",
  },
  {
    label: "Lifesciences",
    value: "Lifesciences",
  },
  {
    label: "Lifts",
    value: "Lifts",
  },
  {
    label: "LINAC14",
    value: "LINAC14",
  },
  {
    label: "Linac3 report team",
    value: "Linac3 report team",
  },
  {
    label: "Linac4",
    value: "Linac4",
  },
  {
    label: "Linac4 and PSB operations",
    value: "Linac4 and PSB operations",
  },
  {
    label: "LINAC4 and PSB operations related information",
    value: "LINAC4 and PSB operations related information",
  },
  {
    label: "Linac4 Project",
    value: "Linac4 Project",
  },
  {
    label: "Linux at CERN",
    value: "Linux at CERN",
  },
  {
    label: "List of persons invited in the meetings of the ABP-HSI sect",
    value: "List of persons invited in the meetings of the ABP-HSI sect",
  },
  {
    label: "Lista docenti scuole ArtScience Bari",
    value: "Lista docenti scuole ArtScience Bari",
  },
  {
    label: "LIU - LHC Injectors Upgrade",
    value: "LIU - LHC Injectors Upgrade",
  },
  {
    label: "LIU-SPS-BL-P-TL WGs email cc list",
    value: "LIU-SPS-BL-P-TL WGs email cc list",
  },
  {
    label: "LKr experts list",
    value: "LKr experts list",
  },
  {
    label: "LLP Nikhef Workshop Admins",
    value: "LLP Nikhef Workshop Admins",
  },
  {
    label: "LMF-HV-TEST",
    value: "LMF-HV-TEST",
  },
  {
    label: "Local Communication",
    value: "Local Communication",
  },
  {
    label: "Local Organizing Committee",
    value: "Local Organizing Committee",
  },
  {
    label: "Log Shipping and Search Service",
    value: "Log Shipping and Search Service",
  },
  {
    label: "Logistic",
    value: "Logistic",
  },
  {
    label: "long-lived particles",
    value: "long-lived particles",
  },
  {
    label: "Long-lived particles Community",
    value: "Long-lived particles Community",
  },
  {
    label: "low emittance ring workshop 2024",
    value: "low emittance ring workshop 2024",
  },
  {
    label: "LPC DM",
    value: "LPC DM",
  },
  {
    label: "LPC Phase 2 simulation and reconstruction",
    value: "LPC Phase 2 simulation and reconstruction",
  },
  {
    label: "LpGBT",
    value: "LpGBT",
  },
  {
    label: "LS1",
    value: "LS1",
  },
  {
    label: "LS2",
    value: "LS2",
  },
  {
    label: "LS2-DISMAC",
    value: "LS2-DISMAC",
  },
  {
    label: "LS3",
    value: "LS3",
  },
  {
    label: "Luminosity  beam instrumentation",
    value: "Luminosity  beam instrumentation",
  },
  {
    label: "Lunch",
    value: "Lunch",
  },
  {
    label: "Mac Support",
    value: "Mac Support",
  },
  {
    label: "Machine Learning",
    value: "Machine Learning",
  },
  {
    label: "Machine learning for CMS simulation",
    value: "Machine learning for CMS simulation",
  },
  {
    label: "Machine learning studies",
    value: "Machine learning studies",
  },
  {
    label: "Machine Protection",
    value: "Machine Protection",
  },
  {
    label: "Magnet Evaluation Board topics",
    value: "Magnet Evaluation Board topics",
  },
  {
    label: "Magnetic Measurements",
    value: "Magnetic Measurements",
  },
  {
    label: "Mail",
    value: "Mail",
  },
  {
    label: "mailing list",
    value: "mailing list",
  },
  {
    label: "mailing list for  messages from LSF",
    value: "mailing list for  messages from LSF",
  },
  {
    label: "Maintenance  Installation",
    value: "Maintenance  Installation",
  },
  {
    label: "Maintenance Management",
    value: "Maintenance Management",
  },
  {
    label: "Maintenance of machine tool",
    value: "Maintenance of machine tool",
  },
  {
    label: "Malax",
    value: "Malax",
  },
  {
    label: "MALT",
    value: "MALT",
  },
  {
    label: "manage myIP software implementation",
    value: "manage myIP software implementation",
  },
  {
    label: "Management",
    value: "Management",
  },
  {
    label: "Marie Curie",
    value: "Marie Curie",
  },
  {
    label: "Mathusla",
    value: "Mathusla",
  },
  {
    label: "Matrix Element Method",
    value: "Matrix Element Method",
  },
  {
    label: "Maxrad access list",
    value: "Maxrad access list",
  },
  {
    label: "MC generators management",
    value: "MC generators management",
  },
  {
    label: "MCnet",
    value: "MCnet",
  },
  {
    label: "MCnet journal club",
    value: "MCnet journal club",
  },
  {
    label: "MCPLOTS",
    value: "MCPLOTS",
  },
  {
    label: "mcplotsCMS",
    value: "mcplotsCMS",
  },
  {
    label: "mechlab admins",
    value: "mechlab admins",
  },
  {
    label: "MEDAMI",
    value: "MEDAMI",
  },
  {
    label: "medaustron",
    value: "medaustron",
  },
  {
    label: "MedAustron control system general",
    value: "MedAustron control system general",
  },
  {
    label: "Media Visits",
    value: "Media Visits",
  },
  {
    label: "Medialab",
    value: "Medialab",
  },
  {
    label: "MediaLab Projects",
    value: "MediaLab Projects",
  },
  {
    label: "Medical Applications",
    value: "Medical Applications",
  },
  {
    label: "MEDICIS",
    value: "MEDICIS",
  },
  {
    label: "MEDICIS Robot",
    value: "MEDICIS Robot",
  },
  {
    label: "Members of GAC-EPA  committee",
    value: "Members of GAC-EPA  committee",
  },
  {
    label: "Methodical Accelerator Design",
    value: "Methodical Accelerator Design",
  },
  {
    label: "Micro Pattern Technologies",
    value: "Micro Pattern Technologies",
  },
  {
    label: "Microfabrication",
    value: "Microfabrication",
  },
  {
    label: "Microsoft Project Server 2016",
    value: "Microsoft Project Server 2016",
  },
  {
    label: "milliQan Experiment",
    value: "milliQan Experiment",
  },
  {
    label: "Miniball",
    value: "Miniball",
  },
  {
    label: "MiniCProject",
    value: "MiniCProject",
  },
  {
    label: "MISS Application",
    value: "MISS Application",
  },
  {
    label: "mit analysis",
    value: "mit analysis",
  },
  {
    label: "Mix volley club",
    value: "Mix volley club",
  },
  {
    label: "mobicall",
    value: "mobicall",
  },
  {
    label: "Mobile Device Management",
    value: "Mobile Device Management",
  },
  {
    label: "MOBILITY",
    value: "MOBILITY",
  },
  {
    label: "modesti pgs",
    value: "modesti pgs",
  },
  {
    label: "MoEDAL",
    value: "MoEDAL",
  },
  {
    label: "MoEDAL Computing Group",
    value: "MoEDAL Computing Group",
  },
  {
    label: "MoEDAL Machine Learning and Nuclear Track Detectors",
    value: "MoEDAL Machine Learning and Nuclear Track Detectors",
  },
  {
    label: "MoEDAL Media and Communications",
    value: "MoEDAL Media and Communications",
  },
  {
    label: "Monitoring",
    value: "Monitoring",
  },
  {
    label: "Monthly meetings between ALICE and CERN IT",
    value: "Monthly meetings between ALICE and CERN IT",
  },
  {
    label: "MRI-PET",
    value: "MRI-PET",
  },
  {
    label: "ms-evaluation",
    value: "ms-evaluation",
  },
  {
    label: "MuCol",
    value: "MuCol",
  },
  {
    label: "Mucoll higgs to tautau analysis",
    value: "Mucoll higgs to tautau analysis",
  },
  {
    label: "Muon Collider Study Group",
    value: "Muon Collider Study Group",
  },
  {
    label: "muon developments",
    value: "muon developments",
  },
  {
    label: "muon electron elastic scattering",
    value: "muon electron elastic scattering",
  },
  {
    label: "Muon Radiography",
    value: "Muon Radiography",
  },
  {
    label: "Muon Shower Detection",
    value: "Muon Shower Detection",
  },
  {
    label: "MUonE",
    value: "MUonE",
  },
  {
    label: "MUonE ECAL",
    value: "MUonE ECAL",
  },
  {
    label: "Music  BBQ ",
    value: "Music  BBQ ",
  },
  {
    label: "MusiClub",
    value: "MusiClub",
  },
  {
    label: "Mutual Aid Fund",
    value: "Mutual Aid Fund",
  },
  {
    label: "NA48-drafts",
    value: "NA48-drafts",
  },
  {
    label: "NA49",
    value: "NA49",
  },
  {
    label: "NA61SHINE",
    value: "NA61SHINE",
  },
  {
    label: "NA62",
    value: "NA62",
  },
  {
    label: "NA62 DCS git",
    value: "NA62 DCS git",
  },
  {
    label: "NA62 LKRL0 ",
    value: "NA62 LKRL0 ",
  },
  {
    label: "NA62 MUV12 experts",
    value: "NA62 MUV12 experts",
  },
  {
    label: "NA62 RICH an call team",
    value: "NA62 RICH an call team",
  },
  {
    label: "NA62 shifter training",
    value: "NA62 shifter training",
  },
  {
    label: "NA62 Vacuum",
    value: "NA62 Vacuum",
  },
  {
    label: "NA62-Drafts",
    value: "NA62-Drafts",
  },
  {
    label: "na62dcs",
    value: "na62dcs",
  },
  {
    label: "na62dcs NewCHOD Expert",
    value: "na62dcs NewCHOD Expert",
  },
  {
    label: "NA62TDC users",
    value: "NA62TDC users",
  },
  {
    label: "NA64 experiment",
    value: "NA64 experiment",
  },
  {
    label: "Named Data Networking",
    value: "Named Data Networking",
  },
  {
    label: "Nano",
    value: "Nano",
  },
  {
    label: "NanoAOD with PF candidates",
    value: "NanoAOD with PF candidates",
  },
  {
    label: "National Groups",
    value: "National Groups",
  },
  {
    label: "nd280 upgrade",
    value: "nd280 upgrade",
  },
  {
    label: "NEAR",
    value: "NEAR",
  },
  {
    label: "Network",
    value: "Network",
  },
  {
    label: "Netzwerk Teilchenwelt",
    value: "Netzwerk Teilchenwelt",
  },
  {
    label: "Neutrino Near Detectors",
    value: "Neutrino Near Detectors",
  },
  {
    label: "Neutrino Platform",
    value: "Neutrino Platform",
  },
  {
    label: "neutrino platform steering group",
    value: "neutrino platform steering group",
  },
  {
    label: "Neutrinos",
    value: "Neutrinos",
  },
  {
    label: "New AMS distribution List Revised 8 July 2021",
    value: "New AMS distribution List Revised 8 July 2021",
  },
  {
    label: "New design form egroup",
    value: "New design form egroup",
  },
  {
    label: "NEWTS",
    value: "NEWTS",
  },
  {
    label: "Next experiment",
    value: "Next experiment",
  },
  {
    label: "NextGen Triggers",
    value: "NextGen Triggers",
  },
  {
    label: "NMSSM theo-exp discussions",
    value: "NMSSM theo-exp discussions",
  },
  {
    label: "NORMA",
    value: "NORMA",
  },
  {
    label: "North Area Consolidation",
    value: "North Area Consolidation",
  },
  {
    label: "NorwayCERN",
    value: "NorwayCERN",
  },
  {
    label: "npax conference organization",
    value: "npax conference organization",
  },
  {
    label: "nTOF",
    value: "nTOF",
  },
  {
    label: "NUCLEUS experiment",
    value: "NUCLEUS experiment",
  },
  {
    label: "NXCALS",
    value: "NXCALS",
  },
  {
    label: "OC",
    value: "OC",
  },
  {
    label: "Occupational Health Service",
    value: "Occupational Health Service",
  },
  {
    label: "ODP",
    value: "ODP",
  },
  {
    label: "Ombud",
    value: "Ombud",
  },
  {
    label: "OMS portal root",
    value: "OMS portal root",
  },
  {
    label: "Online Model User",
    value: "Online Model User",
  },
  {
    label: "OPAL",
    value: "OPAL",
  },
  {
    label: "OPC",
    value: "OPC",
  },
  {
    label: "OPC Access",
    value: "OPC Access",
  },
  {
    label: "Open Access",
    value: "Open Access",
  },
  {
    label: "Open Data",
    value: "Open Data",
  },
  {
    label: "Open Day",
    value: "Open Day",
  },
  {
    label: "Open Days 2019",
    value: "Open Days 2019",
  },
  {
    label: "Open Hardware",
    value: "Open Hardware",
  },
  {
    label: "Open Loops development",
    value: "Open Loops development",
  },
  {
    label: "Open Science",
    value: "Open Science",
  },
  {
    label: "Open Source Software Management",
    value: "Open Source Software Management",
  },
  {
    label: "OpenAIRE",
    value: "OpenAIRE",
  },
  {
    label: "openlab",
    value: "openlab",
  },
  {
    label: "opensearch",
    value: "opensearch",
  },
  {
    label: "OpenSkyLab",
    value: "OpenSkyLab",
  },
  {
    label: "OpenStack",
    value: "OpenStack",
  },
  {
    label: "OPERA Experiment",
    value: "OPERA Experiment",
  },
  {
    label: "Operations KB update",
    value: "Operations KB update",
  },
  {
    label: "OPG",
    value: "OPG",
  },
  {
    label: "OQI",
    value: "OQI",
  },
  {
    label: "Oracle",
    value: "Oracle",
  },
  {
    label: "Oracle Source Manager",
    value: "Oracle Source Manager",
  },
  {
    label: "ordan David Walker",
    value: "ordan David Walker",
  },
  {
    label: "OSPO",
    value: "OSPO",
  },
  {
    label: "OSS",
    value: "OSS",
  },
  {
    label: "Outreach",
    value: "Outreach",
  },
  {
    label: "Outside ATLAS week",
    value: "Outside ATLAS week",
  },
  {
    label: "OWS.EU",
    value: "OWS.EU",
  },
  {
    label: "p1588-test",
    value: "p1588-test",
  },
  {
    label: "PAC",
    value: "PAC",
  },
  {
    label: "PACS",
    value: "PACS",
  },
  {
    label: "PadelTournament",
    value: "PadelTournament",
  },
  {
    label: "Panorama default access",
    value: "Panorama default access",
  },
  {
    label: "PaperAuthors",
    value: "PaperAuthors",
  },
  {
    label: "Particle Data Group",
    value: "Particle Data Group",
  },
  {
    label: "Particle Flow convenors at CMS",
    value: "Particle Flow convenors at CMS",
  },
  {
    label: "Particle Physics and Astronomy in Austria",
    value: "Particle Physics and Astronomy in Austria",
  },
  {
    label: "PARTNER",
    value: "PARTNER",
  },
  {
    label: "Partonic interactions in matter",
    value: "Partonic interactions in matter",
  },
  {
    label: "Party",
    value: "Party",
  },
  {
    label: "PBC-BSM-FPC-Meetings",
    value: "PBC-BSM-FPC-Meetings",
  },
  {
    label: "PBC-MAILING",
    value: "PBC-MAILING",
  },
  {
    label: "PBC-WG-CONVENERS",
    value: "PBC-WG-CONVENERS",
  },
  {
    label: "PBC-WG-MEMBERS",
    value: "PBC-WG-MEMBERS",
  },
  {
    label: "PC Hardening",
    value: "PC Hardening",
  },
  {
    label: "PCTO INFN-Bari-Scuole ArteScienza",
    value: "PCTO INFN-Bari-Scuole ArteScienza",
  },
  {
    label: "Pension Fund Reporting",
    value: "Pension Fund Reporting",
  },
  {
    label: "Pentaho",
    value: "Pentaho",
  },
  {
    label: "person responsible for archiving raw data",
    value: "person responsible for archiving raw data",
  },
  {
    label: "PF Actuarial Reports",
    value: "PF Actuarial Reports",
  },
  {
    label: "PH admin",
    value: "PH admin",
  },
  {
    label: "PH AFS group",
    value: "PH AFS group",
  },
  {
    label: "PH-AGS",
    value: "PH-AGS",
  },
  {
    label: "PH-AGS-SI",
    value: "PH-AGS-SI",
  },
  {
    label: "PH-DT-section",
    value: "PH-DT-section",
  },
  {
    label: "PH-ESE-BE MMC Project",
    value: "PH-ESE-BE MMC Project",
  },
  {
    label: "PH-ESS-BE",
    value: "PH-ESS-BE",
  },
  {
    label: "PH-SEMINARS",
    value: "PH-SEMINARS",
  },
  {
    label: "PH-SFT",
    value: "PH-SFT",
  },
  {
    label: "PH-SSD",
    value: "PH-SSD",
  },
  {
    label: "Phase II Neutron Monitors  CMS",
    value: "Phase II Neutron Monitors  CMS",
  },
  {
    label: "Phd and research project",
    value: "Phd and research project",
  },
  {
    label: "PHOS upgrade to P2P readout",
    value: "PHOS upgrade to P2P readout",
  },
  {
    label: "Photo team",
    value: "Photo team",
  },
  {
    label: "Photo-Club",
    value: "Photo-Club",
  },
  {
    label: "Photoemission Laboratory",
    value: "Photoemission Laboratory",
  },
  {
    label: "Photonics",
    value: "Photonics",
  },
  {
    label: "physicists and students in Universidad de Sonora Group",
    value: "physicists and students in Universidad de Sonora Group",
  },
  {
    label: "Physics",
    value: "Physics",
  },
  {
    label: "Physics Analyses",
    value: "Physics Analyses",
  },
  {
    label: "Physics Beyond Colliders",
    value: "Physics Beyond Colliders",
  },
  {
    label: "Physics comparisons and Generator Tunes",
    value: "Physics comparisons and Generator Tunes",
  },
  {
    label: "Physics Department Safety Officers Central eMail",
    value: "Physics Department Safety Officers Central eMail",
  },
  {
    label: "Physics in Collision International Advisory",
    value: "Physics in Collision International Advisory",
  },
  {
    label: "PicoSEC project",
    value: "PicoSEC project",
  },
  {
    label: "PIE procedures review",
    value: "PIE procedures review",
  },
  {
    label: "Piezo Goniometer Development",
    value: "Piezo Goniometer Development",
  },
  {
    label: "PiGBT",
    value: "PiGBT",
  },
  {
    label: "pilotta",
    value: "pilotta",
  },
  {
    label: "Pipe joining techniques community",
    value: "Pipe joining techniques community",
  },
  {
    label: "piquet",
    value: "piquet",
  },
  {
    label: "Piquet service",
    value: "Piquet service",
  },
  {
    label: "PKU CMS group",
    value: "PKU CMS group",
  },
  {
    label: "PKU Multiboson",
    value: "PKU Multiboson",
  },
  {
    label: "PLAN tool",
    value: "PLAN tool",
  },
  {
    label: "plasma wakefield",
    value: "plasma wakefield",
  },
  {
    label: "PLC Management",
    value: "PLC Management",
  },
  {
    label: "PLM",
    value: "PLM",
  },
  {
    label: "POSICS",
    value: "POSICS",
  },
  {
    label: "Position Sensitive Detectors",
    value: "Position Sensitive Detectors",
  },
  {
    label: "postls3",
    value: "postls3",
  },
  {
    label: "PPS Electronics for HL-LHC",
    value: "PPS Electronics for HL-LHC",
  },
  {
    label: "PRIN-HTIME",
    value: "PRIN-HTIME",
  },
  {
    label: "Printshop",
    value: "Printshop",
  },
  {
    label: "Privacy by Design",
    value: "Privacy by Design",
  },
  {
    label: "PRIVATE",
    value: "PRIVATE",
  },
  {
    label: "Procurement",
    value: "Procurement",
  },
  {
    label: "Project  Experiment Safety Support",
    value: "Project  Experiment Safety Support",
  },
  {
    label: "Project Management",
    value: "Project Management",
  },
  {
    label: "Project Management Platform",
    value: "Project Management Platform",
  },
  {
    label: "Project-network",
    value: "Project-network",
  },
  {
    label: "Protocol or National visits",
    value: "Protocol or National visits",
  },
  {
    label: "ProtoDUNE",
    value: "ProtoDUNE",
  },
  {
    label: "Proximeter device",
    value: "Proximeter device",
  },
  {
    label: "PS",
    value: "PS",
  },
  {
    label: "PS COMPLEX",
    value: "PS COMPLEX",
  },
  {
    label: "PS COMPLEX COORDINATION",
    value: "PS COMPLEX COORDINATION",
  },
  {
    label: "PS SPS Coordination",
    value: "PS SPS Coordination",
  },
  {
    label: "PS-Irradiation facilities",
    value: "PS-Irradiation facilities",
  },
  {
    label: "PSEN",
    value: "PSEN",
  },
  {
    label: "PSEN FOLLOW UP",
    value: "PSEN FOLLOW UP",
  },
  {
    label: "PSS-CONS",
    value: "PSS-CONS",
  },
  {
    label: "Publishing",
    value: "Publishing",
  },
  {
    label: "puppet hostgroup",
    value: "puppet hostgroup",
  },
  {
    label: "Purchasing Procedures",
    value: "Purchasing Procedures",
  },
  {
    label: "PURESAFE",
    value: "PURESAFE",
  },
  {
    label: "PyHEP",
    value: "PyHEP",
  },
  {
    label: "pyhf workshop series",
    value: "pyhf workshop series",
  },
  {
    label: "Python development",
    value: "Python development",
  },
  {
    label: "PYTIMBER",
    value: "PYTIMBER",
  },
  {
    label: "QAC",
    value: "QAC",
  },
  {
    label: "QM2014",
    value: "QM2014",
  },
  {
    label: "QM2019",
    value: "QM2019",
  },
  {
    label: "QPS support",
    value: "QPS support",
  },
  {
    label: "QTI Initiative",
    value: "QTI Initiative",
  },
  {
    label: "Qualiac",
    value: "Qualiac",
  },
  {
    label: "Quantum Technology Initiative",
    value: "Quantum Technology Initiative",
  },
  {
    label: "Quench Test Strategy",
    value: "Quench Test Strategy",
  },
  {
    label: "R2E",
    value: "R2E",
  },
  {
    label: "RADE LabVIEW administrators",
    value: "RADE LabVIEW administrators",
  },
  {
    label: "RADECS",
    value: "RADECS",
  },
  {
    label: "Radiation Damage In CCDs (RADAC)",
    value: "Radiation Damage In CCDs (RADAC)",
  },
  {
    label: "Radiation Protection online services",
    value: "Radiation Protection online services",
  },
  {
    label: "Radiation Safety",
    value: "Radiation Safety",
  },
  {
    label: "Radiation Test Facilities",
    value: "Radiation Test Facilities",
  },
  {
    label: "Radiation To Electronics (R2E)",
    value: "Radiation To Electronics (R2E)",
  },
  {
    label: "Radiation to Materials and Electronics",
    value: "Radiation to Materials and Electronics",
  },
  {
    label: "radioactive sources",
    value: "radioactive sources",
  },
  {
    label: "Radioactive Waste",
    value: "Radioactive Waste",
  },
  {
    label: "RADMON",
    value: "RADMON",
  },
  {
    label: "RADNEXT H2020 project",
    value: "RADNEXT H2020 project",
  },
  {
    label: "RADSAGA ITN",
    value: "RADSAGA ITN",
  },
  {
    label: "RAMSES",
    value: "RAMSES",
  },
  {
    label: "RAMSES Program",
    value: "RAMSES Program",
  },
  {
    label: "RAW",
    value: "RAW",
  },
  {
    label: "RCS Scrutiny Group",
    value: "RCS Scrutiny Group",
  },
  {
    label: "RD of new semiconductor sensors and detectors",
    value: "RD of new semiconductor sensors and detectors",
  },
  {
    label: "RD42",
    value: "RD42",
  },
  {
    label: "RD50",
    value: "RD50",
  },
  {
    label: "RD51",
    value: "RD51",
  },
  {
    label: "RD51 DAQ",
    value: "RD51 DAQ",
  },
  {
    label: "RD51-WG7 Common Test Facilities",
    value: "RD51-WG7 Common Test Facilities",
  },
  {
    label: "RD53",
    value: "RD53",
  },
  {
    label: "RDS EDA services",
    value: "RDS EDA services",
  },
  {
    label: "RE37",
    value: "RE37",
  },
  {
    label: "Reading Club",
    value: "Reading Club",
  },
  {
    label: "readthedocs",
    value: "readthedocs",
  },
  {
    label: "Reconstruction implementations using neural networks",
    value: "Reconstruction implementations using neural networks",
  },
  {
    label: "Recruitment Service",
    value: "Recruitment Service",
  },
  {
    label: "Reinterpretation",
    value: "Reinterpretation",
  },
  {
    label: "REMUS",
    value: "REMUS",
  },
  {
    label: "RENAFAE",
    value: "RENAFAE",
  },
  {
    label: "ReportingTool",
    value: "ReportingTool",
  },
  {
    label: "Research Group",
    value: "Research Group",
  },
  {
    label: "reunion",
    value: "reunion",
  },
  {
    label: "reviewers group",
    value: "reviewers group",
  },
  {
    label: "RF Sequencer Logs",
    value: "RF Sequencer Logs",
  },
  {
    label: "RF systems",
    value: "RF systems",
  },
  {
    label: "RILIS",
    value: "RILIS",
  },
  {
    label: "Risk Management",
    value: "Risk Management",
  },
  {
    label: "Rivet",
    value: "Rivet",
  },
  {
    label: "robots software and thinkering club",
    value: "robots software and thinkering club",
  },
  {
    label: "Room Booking",
    value: "Room Booking",
  },
  {
    label: "ROOT",
    value: "ROOT",
  },
  {
    label: "ROSCOE",
    value: "ROSCOE",
  },
  {
    label: "RP Admin",
    value: "RP Admin",
  },
  {
    label: "RP Archive Access",
    value: "RP Archive Access",
  },
  {
    label: "RP BDD",
    value: "RP BDD",
  },
  {
    label: "RP Coflu cluster",
    value: "RP Coflu cluster",
  },
  {
    label: "RP Contractor",
    value: "RP Contractor",
  },
  {
    label: "RP DFS",
    value: "RP DFS",
  },
  {
    label: "RP EDMS",
    value: "RP EDMS",
  },
  {
    label: "RP Global",
    value: "RP Global",
  },
  {
    label: "RP Mailing",
    value: "RP Mailing",
  },
  {
    label: "RP MEMBERS BAT 561",
    value: "RP MEMBERS BAT 561",
  },
  {
    label: "RP Radio-analytical Services",
    value: "RP Radio-analytical Services",
  },
  {
    label: "RP Rights",
    value: "RP Rights",
  },
  {
    label: "RP SMS",
    value: "RP SMS",
  },
  {
    label: "RP Specific",
    value: "RP Specific",
  },
  {
    label: "RP Web",
    value: "RP Web",
  },
  {
    label: "rp-access-stockage-source",
    value: "rp-access-stockage-source",
  },
  {
    label: "RP-APEX-ADMIN",
    value: "RP-APEX-ADMIN",
  },
  {
    label: "RP-Characterization",
    value: "RP-Characterization",
  },
  {
    label: "RSOC",
    value: "RSOC",
  },
  {
    label: "Run 2 diphoton search",
    value: "Run 2 diphoton search",
  },
  {
    label: "Running",
    value: "Running",
  },
  {
    label: "S327",
    value: "S327",
  },
  {
    label: "SACAQM",
    value: "SACAQM",
  },
  {
    label: "safe",
    value: "safe",
  },
  {
    label: "Safety",
    value: "Safety",
  },
  {
    label: "Safety  Radiation Protection",
    value: "Safety  Radiation Protection",
  },
  {
    label: "Safety  Radiation Protection Services",
    value: "Safety  Radiation Protection Services",
  },
  {
    label: "Safety Budget",
    value: "Safety Budget",
  },
  {
    label: "Safety Computing Support",
    value: "Safety Computing Support",
  },
  {
    label: "Safety Inspections",
    value: "Safety Inspections",
  },
  {
    label: "Safety Officers",
    value: "Safety Officers",
  },
  {
    label: "safety radiation support officer",
    value: "safety radiation support officer",
  },
  {
    label: "Safety Training",
    value: "Safety Training",
  },
  {
    label: "SafetyComputing SSO rules",
    value: "SafetyComputing SSO rules",
  },
  {
    label: "SAILOR",
    value: "SAILOR",
  },
  {
    label: "SAM IN PLC Programmation",
    value: "SAM IN PLC Programmation",
  },
  {
    label: "Sapore Gravis network",
    value: "Sapore Gravis network",
  },
  {
    label: "SBA",
    value: "SBA",
  },
  {
    label: "SBA users",
    value: "SBA users",
  },
  {
    label: "SCADA Application Service",
    value: "SCADA Application Service",
  },
  {
    label: "Scale and CVI info for the FAP department",
    value: "Scale and CVI info for the FAP department",
  },
  {
    label: "SCE  - Site and Civil Engineering",
    value: "SCE  - Site and Civil Engineering",
  },
  {
    label: "SCE Operations and Logistics",
    value: "SCE Operations and Logistics",
  },
  {
    label: "Science Communication Hackathon",
    value: "Science Communication Hackathon",
  },
  {
    label: "Science Gateway",
    value: "Science Gateway",
  },
  {
    label: "Science in School",
    value: "Science in School",
  },
  {
    label: "SciencePAD",
    value: "SciencePAD",
  },
  {
    label: "ScienceSoft",
    value: "ScienceSoft",
  },
  {
    label: "Scientific Committees",
    value: "Scientific Committees",
  },
  {
    label: "Scientific Information",
    value: "Scientific Information",
  },
  {
    label: "SciFiNet Marie Curie proposal",
    value: "SciFiNet Marie Curie proposal",
  },
  {
    label: "SCT-TRT Environmental Issues",
    value: "SCT-TRT Environmental Issues",
  },
  {
    label: "SDCC",
    value: "SDCC",
  },
  {
    label: "Section Leader",
    value: "Section Leader",
  },
  {
    label: "security",
    value: "security",
  },
  {
    label: "Security Committee ",
    value: "Security Committee ",
  },
  {
    label: "SecurityBadge",
    value: "SecurityBadge",
  },
  {
    label: "SecurityKeys",
    value: "SecurityKeys",
  },
  {
    label: "SecuritySite",
    value: "SecuritySite",
  },
  {
    label: "SEEIIST",
    value: "SEEIIST",
  },
  {
    label: "Seminar",
    value: "Seminar",
  },
  {
    label: "Seminars and Colloquia",
    value: "Seminars and Colloquia",
  },
  {
    label: "Sentry Error Tracking",
    value: "Sentry Error Tracking",
  },
  {
    label: "SERCO",
    value: "SERCO",
  },
  {
    label: "SERENITY",
    value: "SERENITY",
  },
  {
    label: "Service Desk staff",
    value: "Service Desk staff",
  },
  {
    label: "Service Management",
    value: "Service Management",
  },
  {
    label: "Session Manager Access Rights",
    value: "Session Manager Access Rights",
  },
  {
    label: "SFT",
    value: "SFT",
  },
  {
    label: "SFT-SPI developers list for Jira",
    value: "SFT-SPI developers list for Jira",
  },
  {
    label: "SGM",
    value: "SGM",
  },
  {
    label: "Shanghai Dark Photon Search",
    value: "Shanghai Dark Photon Search",
  },
  {
    label: "Shears",
    value: "Shears",
  },
  {
    label: "ShiftersList",
    value: "ShiftersList",
  },
  {
    label: "Shihmen-100 Software",
    value: "Shihmen-100 Software",
  },
  {
    label: "SHiP calorimeters and PID",
    value: "SHiP calorimeters and PID",
  },
  {
    label: "SHiP Computing",
    value: "SHiP Computing",
  },
  {
    label: "SHiP Engineering",
    value: "SHiP Engineering",
  },
  {
    label: "SHIP Experiment",
    value: "SHIP Experiment",
  },
  {
    label: "SHiP SBT",
    value: "SHiP SBT",
  },
  {
    label: "SHiP Spectrometer Tracker",
    value: "SHiP Spectrometer Tracker",
  },
  {
    label: "Shop",
    value: "Shop",
  },
  {
    label: "sidis",
    value: "sidis",
  },
  {
    label: "SIMBA",
    value: "SIMBA",
  },
  {
    label: "SImulation and Geometry",
    value: "SImulation and Geometry",
  },
  {
    label: "Simulations",
    value: "Simulations",
  },
  {
    label: "sindes change log",
    value: "sindes change log",
  },
  {
    label: "sindes service administrator",
    value: "sindes service administrator",
  },
  {
    label: "SIS-Archive",
    value: "SIS-Archive",
  },
  {
    label: "sitemigration",
    value: "sitemigration",
  },
  {
    label: "SiW-ECAL",
    value: "SiW-ECAL",
  },
  {
    label: "Ski Rando",
    value: "Ski Rando",
  },
  {
    label: "ski-club",
    value: "ski-club",
  },
  {
    label: "SKKU",
    value: "SKKU",
  },
  {
    label: "sm ewk exclusive WW",
    value: "sm ewk exclusive WW",
  },
  {
    label: "SM WZ analysis ",
    value: "SM WZ analysis ",
  },
  {
    label: "Small collisional systems",
    value: "Small collisional systems",
  },
  {
    label: "SMB Service Management and Support",
    value: "SMB Service Management and Support",
  },
  {
    label: "SMB Site Services Management",
    value: "SMB Site Services Management",
  },
  {
    label: "SMM group",
    value: "SMM group",
  },
  {
    label: "SMS alerting",
    value: "SMS alerting",
  },
  {
    label: "SND at LHC Experiment",
    value: "SND at LHC Experiment",
  },
  {
    label: "SND-LHC Experiment",
    value: "SND-LHC Experiment",
  },
  {
    label: "Snow",
    value: "Snow",
  },
  {
    label: "SNOW-Ticketing",
    value: "SNOW-Ticketing",
  },
  {
    label: "SNU Vcb analysis group",
    value: "SNU Vcb analysis group",
  },
  {
    label: "SO Sector management",
    value: "SO Sector management",
  },
  {
    label: "Social",
    value: "Social",
  },
  {
    label: "Social Media",
    value: "Social Media",
  },
  {
    label: "Social Networks",
    value: "Social Networks",
  },
  {
    label: "software",
    value: "software",
  },
  {
    label: "software development",
    value: "software development",
  },
  {
    label: "Software ECR",
    value: "Software ECR",
  },
  {
    label: "software licences",
    value: "software licences",
  },
  {
    label: "SOPHIAN SABRI",
    value: "SOPHIAN SABRI",
  },
  {
    label: "spacal-rd",
    value: "spacal-rd",
  },
  {
    label: "space administration",
    value: "space administration",
  },
  {
    label: "spares",
    value: "spares",
  },
  {
    label: "Sparks",
    value: "Sparks",
  },
  {
    label: "Sparks! Forum",
    value: "Sparks! Forum",
  },
  {
    label: "SpecMAT",
    value: "SpecMAT",
  },
  {
    label: "sPHENIX",
    value: "sPHENIX",
  },
  {
    label: "Sports",
    value: "Sports",
  },
  {
    label: "SPS",
    value: "SPS",
  },
  {
    label: "SPS Fire Safety WP4",
    value: "SPS Fire Safety WP4",
  },
  {
    label: "SPS NA-CONS Fire Safety",
    value: "SPS NA-CONS Fire Safety",
  },
  {
    label: "SPS North Area Consolidation",
    value: "SPS North Area Consolidation",
  },
  {
    label: "SPS operations",
    value: "SPS operations",
  },
  {
    label: "SPS RF Low-Level",
    value: "SPS RF Low-Level",
  },
  {
    label: "SPS RF Low-Level Controls Renovation",
    value: "SPS RF Low-Level Controls Renovation",
  },
  {
    label: "SQM 2016",
    value: "SQM 2016",
  },
  {
    label: "SRF",
    value: "SRF",
  },
  {
    label: "SSD - Solid State Detectors",
    value: "SSD - Solid State Detectors",
  },
  {
    label: "SSM Monitoring",
    value: "SSM Monitoring",
  },
  {
    label: "SSO",
    value: "SSO",
  },
  {
    label: "SST1M",
    value: "SST1M",
  },
  {
    label: "Staff Association",
    value: "Staff Association",
  },
  {
    label: "Standby Service",
    value: "Standby Service",
  },
  {
    label: "star india junior",
    value: "star india junior",
  },
  {
    label: "Starman",
    value: "Starman",
  },
  {
    label: "Statistics for neutrino experiments",
    value: "Statistics for neutrino experiments",
  },
  {
    label: "Statistics for particle physics",
    value: "Statistics for particle physics",
  },
  {
    label: "Statistics for particle physics and neighbouring fields",
    value: "Statistics for particle physics and neighbouring fields",
  },
  {
    label: "Steering board of FTS 3 development",
    value: "Steering board of FTS 3 development",
  },
  {
    label: "STELLA Project",
    value: "STELLA Project",
  },
  {
    label: "stock113",
    value: "stock113",
  },
  {
    label: "stopdilepton",
    value: "stopdilepton",
  },
  {
    label: "Stores Operation",
    value: "Stores Operation",
  },
  {
    label: "Streaming DAQ",
    value: "Streaming DAQ",
  },
  {
    label: "Student Club Activities",
    value: "Student Club Activities",
  },
  {
    label: "Student Programs",
    value: "Student Programs",
  },
  {
    label: "SU Experiment Unit - Extended",
    value: "SU Experiment Unit - Extended",
  },
  {
    label: "sub-project",
    value: "sub-project",
  },
  {
    label: "Summer Students",
    value: "Summer Students",
  },
  {
    label: "support",
    value: "support",
  },
  {
    label: "Support for BI Python GUIs",
    value: "Support for BI Python GUIs",
  },
  {
    label: "Support for Reksio",
    value: "Support for Reksio",
  },
  {
    label: "Support for shared Tier-3 analysis facilities in the US",
    value: "Support for shared Tier-3 analysis facilities in the US",
  },
  {
    label: "Support-line-mailfeed",
    value: "Support-line-mailfeed",
  },
  {
    label: "Survey",
    value: "Survey",
  },
  {
    label: "Survey for Experiments",
    value: "Survey for Experiments",
  },
  {
    label: "Survey Team Activities",
    value: "Survey Team Activities",
  },
  {
    label: "SUSI-TRAKA",
    value: "SUSI-TRAKA",
  },
  {
    label: "SUWG",
    value: "SUWG",
  },
  {
    label: "SVN",
    value: "SVN",
  },
  {
    label: "SY-ABT Admin ",
    value: "SY-ABT Admin ",
  },
  {
    label: "SY-ABT Expert",
    value: "SY-ABT Expert",
  },
  {
    label: "SY-BI GUI support",
    value: "SY-BI GUI support",
  },
  {
    label: "SY-BI-XEI",
    value: "SY-BI-XEI",
  },
  {
    label: "sy-dep-bi",
    value: "sy-dep-bi",
  },
  {
    label: "SY-EPC-CCE",
    value: "SY-EPC-CCE",
  },
  {
    label: "SY-EPC-CCS",
    value: "SY-EPC-CCS",
  },
  {
    label: "SY-RF",
    value: "SY-RF",
  },
  {
    label: "SY-STI",
    value: "SY-STI",
  },
  {
    label: "SY-STI-LP",
    value: "SY-STI-LP",
  },
  {
    label: "SY-STI-RBS",
    value: "SY-STI-RBS",
  },
  {
    label: "SY-STI-TCD",
    value: "SY-STI-TCD",
  },
  {
    label: "SYABT project Inductive adder development",
    value: "SYABT project Inductive adder development",
  },
  {
    label: "SYABT project MTE building relocation",
    value: "SYABT project MTE building relocation",
  },
  {
    label: "system analysis",
    value: "system analysis",
  },
  {
    label: "T2K members at CERN",
    value: "T2K members at CERN",
  },
  {
    label: "TauFV Experiment",
    value: "TauFV Experiment",
  },
  {
    label: "TBPX coordination meetings",
    value: "TBPX coordination meetings",
  },
  {
    label: "TCD Material database admins ",
    value: "TCD Material database admins ",
  },
  {
    label: "tdpac data storage",
    value: "tdpac data storage",
  },
  {
    label: "TE Department",
    value: "TE Department",
  },
  {
    label: "TE department - Safety",
    value: "TE department - Safety",
  },
  {
    label: "TE department LHC LS3 activities",
    value: "TE department LHC LS3 activities",
  },
  {
    label: "TE-ABT Expert",
    value: "TE-ABT Expert",
  },
  {
    label: "TE-CRG",
    value: "TE-CRG",
  },
  {
    label: "TE-CRG Knowledge base",
    value: "TE-CRG Knowledge base",
  },
  {
    label: "TE-CRG-CE",
    value: "TE-CRG-CE",
  },
  {
    label: "TE-CRG-IC",
    value: "TE-CRG-IC",
  },
  {
    label: "TE-CRG-ME",
    value: "TE-CRG-ME",
  },
  {
    label: "TE-CRG-ML",
    value: "TE-CRG-ML",
  },
  {
    label: "TE-CRG-prognostic",
    value: "TE-CRG-prognostic",
  },
  {
    label: "TE-dep-admin",
    value: "TE-dep-admin",
  },
  {
    label: "TE-dep-MSC-staff-admin",
    value: "TE-dep-MSC-staff-admin",
  },
  {
    label: "TE-EDMS",
    value: "TE-EDMS",
  },
  {
    label: "TE-EPC-CCS",
    value: "TE-EPC-CCS",
  },
  {
    label: "TE-EPC-HPMLABO",
    value: "TE-EPC-HPMLABO",
  },
  {
    label: "TE-EPC-MEMBERS",
    value: "TE-EPC-MEMBERS",
  },
  {
    label: "TE-MPE Section",
    value: "TE-MPE Section",
  },
  {
    label: "TE-MPE-CB section",
    value: "TE-MPE-CB section",
  },
  {
    label: "TE-MPE-EE Section",
    value: "TE-MPE-EE Section",
  },
  {
    label: "TE-MSC E-MIP project",
    value: "TE-MSC E-MIP project",
  },
  {
    label: "TE-MSC-Contract",
    value: "TE-MSC-Contract",
  },
  {
    label: "TE-MSC-MNC",
    value: "TE-MSC-MNC",
  },
  {
    label: "TE-MSC-SMT",
    value: "TE-MSC-SMT",
  },
  {
    label: "TE-MSC-TF",
    value: "TE-MSC-TF",
  },
  {
    label: "TE-VSC AL40-30 support industriel",
    value: "TE-VSC AL40-30 support industriel",
  },
  {
    label: "te.msc",
    value: "te.msc",
  },
  {
    label: "TE11",
    value: "TE11",
  },
  {
    label: "Teachers Programme",
    value: "Teachers Programme",
  },
  {
    label: "Team Password Management",
    value: "Team Password Management",
  },
  {
    label: "Technology Transfer",
    value: "Technology Transfer",
  },
  {
    label: "TEDxApp",
    value: "TEDxApp",
  },
  {
    label: "tedxcern",
    value: "tedxcern",
  },
  {
    label: "TERA",
    value: "TERA",
  },
  {
    label: "Test group",
    value: "Test group",
  },
  {
    label: "Testing automatic creation script",
    value: "Testing automatic creation script",
  },
  {
    label: "TFPX Assembly Huddle",
    value: "TFPX Assembly Huddle",
  },
  {
    label: "TFPX Assembly Huddle Managers",
    value: "TFPX Assembly Huddle Managers",
  },
  {
    label: "TH",
    value: "TH",
  },
  {
    label: "TH seminars organisers",
    value: "TH seminars organisers",
  },
  {
    label: "Thailand",
    value: "Thailand",
  },
  {
    label: "The GeoModel Toolkit",
    value: "The GeoModel Toolkit",
  },
  {
    label: "THE Port",
    value: "THE Port",
  },
  {
    label: "The Port - automated feedback system",
    value: "The Port - automated feedback system",
  },
  {
    label: "Theory-LHC",
    value: "Theory-LHC",
  },
  {
    label: "TIARA",
    value: "TIARA",
  },
  {
    label: "Tier3 monitoring dev",
    value: "Tier3 monitoring dev",
  },
  {
    label: "Tile data preparation",
    value: "Tile data preparation",
  },
  {
    label: "Tile-in-ONE Project administrators",
    value: "Tile-in-ONE Project administrators",
  },
  {
    label: "TIle-in-One Project issues",
    value: "TIle-in-One Project issues",
  },
  {
    label: "TileCal phase 2 upgrade",
    value: "TileCal phase 2 upgrade",
  },
  {
    label: "TIM",
    value: "TIM",
  },
  {
    label: "TIM-OP",
    value: "TIM-OP",
  },
  {
    label: "TLEP Design Study",
    value: "TLEP Design Study",
  },
  {
    label: "TMVA Developers",
    value: "TMVA Developers",
  },
  {
    label: "To discuss timing detector RD in the frame of US-Japan",
    value: "To discuss timing detector RD in the frame of US-Japan",
  },
  {
    label: "top",
    value: "top",
  },
  {
    label: "top higgs - korea cms group ",
    value: "top higgs - korea cms group ",
  },
  {
    label: "TOPLHCWG open list",
    value: "TOPLHCWG open list",
  },
  {
    label: "TOTEM",
    value: "TOTEM",
  },
  {
    label: "TOTEM list users emergency SMSemail",
    value: "TOTEM list users emergency SMSemail",
  },
  {
    label: "TOTEM Trigger and DAQ",
    value: "TOTEM Trigger and DAQ",
  },
  {
    label: "TOTEM trigger and DAQ alarms",
    value: "TOTEM trigger and DAQ alarms",
  },
  {
    label: "totem-web-management",
    value: "totem-web-management",
  },
  {
    label: "TPCU cleanroom activities",
    value: "TPCU cleanroom activities",
  },
  {
    label: "Tracker Discussions within India-CMS",
    value: "Tracker Discussions within India-CMS",
  },
  {
    label: "Tracker LS1 Activities",
    value: "Tracker LS1 Activities",
  },
  {
    label: "Travail Temporaire",
    value: "Travail Temporaire",
  },
  {
    label: "TREASURE",
    value: "TREASURE",
  },
  {
    label: "TREC",
    value: "TREC",
  },
  {
    label: "TRIUMF-GRIFFIN",
    value: "TRIUMF-GRIFFIN",
  },
  {
    label: "TSA System",
    value: "TSA System",
  },
  {
    label: "TSM backup",
    value: "TSM backup",
  },
  {
    label: "TSMC technologies support",
    value: "TSMC technologies support",
  },
  {
    label: "TT-PET Project",
    value: "TT-PET Project",
  },
  {
    label: "TTC",
    value: "TTC",
  },
  {
    label: "tunnel asset management ",
    value: "tunnel asset management ",
  },
  {
    label: "TWiki",
    value: "TWiki",
  },
  {
    label: "UCAP",
    value: "UCAP",
  },
  {
    label: "UCAP Camera Devices",
    value: "UCAP Camera Devices",
  },
  {
    label: "UF CMS Group",
    value: "UF CMS Group",
  },
  {
    label: "UK AWP20 Managemnt Team",
    value: "UK AWP20 Managemnt Team",
  },
  {
    label: "UK physicists",
    value: "UK physicists",
  },
  {
    label: "ULICE",
    value: "ULICE",
  },
  {
    label: "Underground facility",
    value: "Underground facility",
  },
  {
    label: "Unfolding",
    value: "Unfolding",
  },
  {
    label: "UNIBS git masters",
    value: "UNIBS git masters",
  },
  {
    label: "UNICOS",
    value: "UNICOS",
  },
  {
    label: "UNIGE-dellaVolpe",
    value: "UNIGE-dellaVolpe",
  },
  {
    label: "Univ. Tsukuba QGP seminar in 2022",
    value: "Univ. Tsukuba QGP seminar in 2022",
  },
  {
    label: "UNOSAT",
    value: "UNOSAT",
  },
  {
    label: "UNOSATs staffs in Bangkok office",
    value: "UNOSATs staffs in Bangkok office",
  },
  {
    label: "upgrade",
    value: "upgrade",
  },
  {
    label: "US ATLAS User Support",
    value: "US ATLAS User Support",
  },
  {
    label: "USATLAS",
    value: "USATLAS",
  },
  {
    label: "USATLAS Upgrade",
    value: "USATLAS Upgrade",
  },
  {
    label: "USCMS Diversity Equity and Inclusion",
    value: "USCMS Diversity Equity and Inclusion",
  },
  {
    label: "USCMS HL-LHC Upgrade",
    value: "USCMS HL-LHC Upgrade",
  },
  {
    label: "USCMS Mentorship Committee",
    value: "USCMS Mentorship Committee",
  },
  {
    label: "USCMS Mentorship Program",
    value: "USCMS Mentorship Program",
  },
  {
    label: "User Support",
    value: "User Support",
  },
  {
    label: "Users",
    value: "Users",
  },
  {
    label: "Users of Leica Laser Trackers at CERN",
    value: "Users of Leica Laser Trackers at CERN",
  },
  {
    label: "users of PCEN33242",
    value: "users of PCEN33242",
  },
  {
    label: "Users Office",
    value: "Users Office",
  },
  {
    label: "users or voharp01 fileserver",
    value: "users or voharp01 fileserver",
  },
  {
    label: "users-building-20-21-168",
    value: "users-building-20-21-168",
  },
  {
    label: "Using patent database",
    value: "Using patent database",
  },
  {
    label: "USLUA",
    value: "USLUA",
  },
  {
    label: "UTMOST CLEEN",
    value: "UTMOST CLEEN",
  },
  {
    label: "UW CMS Computing",
    value: "UW CMS Computing",
  },
  {
    label: "UZH-TH Twiki access",
    value: "UZH-TH Twiki access",
  },
  {
    label: "Vacuum",
    value: "Vacuum",
  },
  {
    label: "Vacuum Operation",
    value: "Vacuum Operation",
  },
  {
    label: "Vacuum Work Orders",
    value: "Vacuum Work Orders",
  },
  {
    label: "VacuumControls",
    value: "VacuumControls",
  },
  {
    label: "VALUE",
    value: "VALUE",
  },
  {
    label: "Vertex Workshop series IAC",
    value: "Vertex Workshop series IAC",
  },
  {
    label: "Vertical Drift",
    value: "Vertical Drift",
  },
  {
    label: "Victoria Cloud Computing",
    value: "Victoria Cloud Computing",
  },
  {
    label: "Videogames",
    value: "Videogames",
  },
  {
    label: "videohr",
    value: "videohr",
  },
  {
    label: "VIP Alumni",
    value: "VIP Alumni",
  },
  {
    label: "VIP visit",
    value: "VIP visit",
  },
  {
    label: "Virtual Reality ",
    value: "Virtual Reality ",
  },
  {
    label: "Virtualization",
    value: "Virtualization",
  },
  {
    label: "Visit",
    value: "Visit",
  },
  {
    label: "visit safety",
    value: "visit safety",
  },
  {
    label: "Visits Service ",
    value: "Visits Service ",
  },
  {
    label: "Visualisation",
    value: "Visualisation",
  },
  {
    label: "VLQ searches with Z-tag and multi-lepton analysis",
    value: "VLQ searches with Z-tag and multi-lepton analysis",
  },
  {
    label: "VMO",
    value: "VMO",
  },
  {
    label: "VMSManagement",
    value: "VMSManagement",
  },
  {
    label: "VolleyBall Club VBC Comite",
    value: "VolleyBall Club VBC Comite",
  },
  {
    label: "VUV-KULEUVEN",
    value: "VUV-KULEUVEN",
  },
  {
    label: "WA104-ICAR-US",
    value: "WA104-ICAR-US",
  },
  {
    label: "WA105 computing",
    value: "WA105 computing",
  },
  {
    label: "WCTE data",
    value: "WCTE data",
  },
  {
    label: "We provide positrons for ASACUSA",
    value: "We provide positrons for ASACUSA",
  },
  {
    label: "Web application development and administration",
    value: "Web application development and administration",
  },
  {
    label: "Webpage developing",
    value: "Webpage developing",
  },
  {
    label: "Website for TE-RAS",
    value: "Website for TE-RAS",
  },
  {
    label: "White-Rabbit",
    value: "White-Rabbit",
  },
  {
    label: "WinCC OA",
    value: "WinCC OA",
  },
  {
    label: "Windows",
    value: "Windows",
  },
  {
    label: "WLCG",
    value: "WLCG",
  },
  {
    label: "WLCG accounting",
    value: "WLCG accounting",
  },
  {
    label: "WLCG Data Management",
    value: "WLCG Data Management",
  },
  {
    label: "WLCG GDPR",
    value: "WLCG GDPR",
  },
  {
    label: "WLCG Information System",
    value: "WLCG Information System",
  },
  {
    label: "WLCG monitorig",
    value: "WLCG monitorig",
  },
  {
    label: "WLCG operations",
    value: "WLCG operations",
  },
  {
    label: "WLCG-Environmental-Sustainability",
    value: "WLCG-Environmental-Sustainability",
  },
  {
    label: "Women in Technology",
    value: "Women in Technology",
  },
  {
    label: "wordpress",
    value: "wordpress",
  },
  {
    label: "workflow languages workshop series",
    value: "workflow languages workshop series",
  },
  {
    label: "Working Group on environmental subjects",
    value: "Working Group on environmental subjects",
  },
  {
    label: "WORKS-MANAGER",
    value: "WORKS-MANAGER",
  },
  {
    label: "WorldFIP repeater task force",
    value: "WorldFIP repeater task force",
  },
  {
    label: "Writing team",
    value: "Writing team",
  },
  {
    label: "xfitter administrators",
    value: "xfitter administrators",
  },
  {
    label: "xldap",
    value: "xldap",
  },
  {
    label: "XrootD",
    value: "XrootD",
  },
  {
    label: "XRootD Collaboration",
    value: "XRootD Collaboration",
  },
  {
    label: "XRootD Release Announcements",
    value: "XRootD Release Announcements",
  },
  {
    label: "XRootD Security",
    value: "XRootD Security",
  },
  {
    label: "XRootD Security Announcements",
    value: "XRootD Security Announcements",
  },
  {
    label: "xTCA",
    value: "xTCA",
  },
  {
    label: "YCC",
    value: "YCC",
  },
];
